/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ACPredictDAGRequestModel,
  ACSinglePredictDAGRequestModel,
  ACTrainModelDAGRequestModel,
  AddModelToModelFamilyRequest,
  AddPredictionToResultsetRequest,
  BodyChangeUserPasswordAuthenticationProtectedChangePasswordPost,
  BodyProgrammaticLoginAuthenticationProgrammaticLoginPost,
  BodyUploadDataFileDataFileUploadPost,
  BodyUploadPredictionPredictionUploadPost,
  CancelDagRunEndpointJobsCancelPostParams,
  CheckDuplicateModelFamilyModelFamilyGetDuplicatesGetParams,
  ClearDAGRunRequest,
  ClearDAGRunResponse,
  ClearTaskRequest,
  ClearTaskResponse,
  CreateModelFamilyRequest,
  CreateModelFamilyResponse,
  CreateResultsetRequest,
  CreateResultsetResponse,
  CreateUserRequest,
  DatasetListResponse,
  DatasetVisualizationDAGRequestModel,
  DeleteDagRunEndpointJobsDeleteParams,
  DeleteModelFamilyModelFamilyModelFamilyIdDeleteParams,
  DeleteResultsetResultsetResultsetIdDeleteParams,
  DownloadDataFileDataFileDownloadDataFileHashGetParams,
  DownloadDatasetDatasetDownloadDatasetHashGetParams,
  DownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGetParams,
  DownloadResultsetResultsetDownloadResultsetIdGetParams,
  EcleanCurationDAGRequestModel,
  GetDataFileTagsDataFileTagsGetParams,
  GetDataFilesCountDataFileCountGetParams,
  GetDataFilesDataFileGet200,
  GetDataFilesDataFileGetParams,
  GetDatasetDataframeDatasetDataframeDatasetHashGetParams,
  GetDatasetProtocolDatasetProtocolDatasetHashGet200,
  GetDatasetTagsDatasetTagsGetParams,
  GetDatasetVersionsDatasetVersionsGetParams,
  GetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGetParams,
  GetDatasetsCountDatasetCountGetParams,
  GetDatasetsDatasetGet200,
  GetDatasetsDatasetGetParams,
  GetDatasetsForReadacrossReadacrossDatasetsGetParams,
  GetJobsJobsGetParams,
  GetModelFamiliesCountModelFamilyCountGetParams,
  GetModelFamiliesModelFamilyGet200,
  GetModelFamiliesModelFamilyGetParams,
  GetModelFamiliesReadacrossModelFamilyDatasetsGetParams,
  GetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGetParams,
  GetModelFamilyTagsModelFamilyTagsGetParams,
  GetModelFamilyVersionsModelFamilyVersionsGetParams,
  GetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGetParams,
  GetModelTagsModelTagsGetParams,
  GetModelsModelGet200,
  GetModelsModelGetParams,
  GetPredictionDataframePredictionDataframePredictionHashGetParams,
  GetPredictionTagsPredictionTagsGetParams,
  GetPredictionsPredictionGet200,
  GetPredictionsPredictionGetParams,
  GetReadacrossCountReadacrossCountGetParams,
  GetReadacrossReadacrossGet200,
  GetReadacrossReadacrossGetParams,
  GetReadacrossTagsReadacrossTagsGetParams,
  GetResultsetExplainabilityResultsetExplainabilityResultsetIdGetParams,
  GetResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet200,
  GetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGetParams,
  GetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet200,
  GetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGetParams,
  GetResultsetResultsetDataframeResultsetIdGetParams,
  GetResultsetTagsResultsetTagsGetParams,
  GetResultsetV2ResultsetDataframeV2ResultsetIdGetParams,
  GetResultsetsCountResultsetCountGetParams,
  GetResultsetsResultsetGet200,
  GetResultsetsResultsetGetParams,
  GetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGetParams,
  GetSinglePredictionResultsetsCountResultsetSinglePredictionCountGetParams,
  GetSinglePredictionResultsetsResultsetSinglePredictionGet200,
  GetSinglePredictionResultsetsResultsetSinglePredictionGetParams,
  GetSinglePredictionTagsPredictionSinglePredictionTagsGetParams,
  GetSuggestedModelMethodsModelTrainSuggestedModelMethodsGetParams,
  GetSupportedModelMethodsModelTrainSupportedModelMethodsGetParams,
  GetTagsTagsGetParams,
  GetTaskJobsTaskGetParams,
  HTTPValidationError,
  LoginAuthenticationLoginGetParams,
  MegaFingerprintsDAGRequestModel,
  MessageResponse,
  Model,
  ModelFamily,
  ModelFamilyDatasetListResponse,
  ModelFamilyListResponse,
  ReadAcrossDAGRequestModel,
  ResultsetExplainabilityResponse,
  TrainModelModelTrainPostParams,
  UpdateDataFileRequest,
  UpdateDatasetRequest,
  UpdateModelRequest,
  UpdatePredictionRequest,
  UpdateReadAcrossRequest,
  UploadDataFileResponse,
  UploadDatasetResponse,
  UploadModelResponse,
  UploadPredictionResponse,
  User,
  UserPasswordRequest,
  UserRolesRequest,
  ValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGet200,
  ValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGetParams
} from '../models'
import { customInstance } from '../custom-instance';



/**
 * @summary Get Current User
 */
export const getCurrentUserUsersCurrentUserGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<User>(
      {url: `/users/current_user`, method: 'GET', signal
    },
      );
    }
  

export const getGetCurrentUserUsersCurrentUserGetQueryKey = () => {
    return [`/users/current_user`] as const;
    }

    
export const getGetCurrentUserUsersCurrentUserGetQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserUsersCurrentUserGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>> = ({ signal }) => getCurrentUserUsersCurrentUserGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentUserUsersCurrentUserGetQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>>
export type GetCurrentUserUsersCurrentUserGetQueryError = unknown


export function useGetCurrentUserUsersCurrentUserGet<TData = Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUserUsersCurrentUserGet<TData = Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUserUsersCurrentUserGet<TData = Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Current User
 */

export function useGetCurrentUserUsersCurrentUserGet<TData = Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserUsersCurrentUserGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentUserUsersCurrentUserGetQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get list of users (metadata ONLY).
Admin sees all roles. Org_admin sees roles with sensitive ones filtered out.
Other users see no role information.
 * @summary Get Users
 */
export const getUsersUsersGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<User[]>(
      {url: `/users/`, method: 'GET', signal
    },
      );
    }
  

export const getGetUsersUsersGetQueryKey = () => {
    return [`/users/`] as const;
    }

    
export const getGetUsersUsersGetQueryOptions = <TData = Awaited<ReturnType<typeof getUsersUsersGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersUsersGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersUsersGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersUsersGet>>> = ({ signal }) => getUsersUsersGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersUsersGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersUsersGetQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersUsersGet>>>
export type GetUsersUsersGetQueryError = unknown


export function useGetUsersUsersGet<TData = Awaited<ReturnType<typeof getUsersUsersGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersUsersGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersUsersGet>>,
          TError,
          Awaited<ReturnType<typeof getUsersUsersGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersUsersGet<TData = Awaited<ReturnType<typeof getUsersUsersGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersUsersGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersUsersGet>>,
          TError,
          Awaited<ReturnType<typeof getUsersUsersGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersUsersGet<TData = Awaited<ReturnType<typeof getUsersUsersGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersUsersGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Users
 */

export function useGetUsersUsersGet<TData = Awaited<ReturnType<typeof getUsersUsersGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersUsersGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersUsersGetQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create User
 */
export const createUserUsersPost = (
    createUserRequest: CreateUserRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<User>(
      {url: `/users/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserRequest, signal
    },
      );
    }
  


export const getCreateUserUsersPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserUsersPost>>, TError,{data: CreateUserRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createUserUsersPost>>, TError,{data: CreateUserRequest}, TContext> => {
    
const mutationKey = ['createUserUsersPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserUsersPost>>, {data: CreateUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  createUserUsersPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserUsersPostMutationResult = NonNullable<Awaited<ReturnType<typeof createUserUsersPost>>>
    export type CreateUserUsersPostMutationBody = CreateUserRequest
    export type CreateUserUsersPostMutationError = HTTPValidationError

    /**
 * @summary Create User
 */
export const useCreateUserUsersPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserUsersPost>>, TError,{data: CreateUserRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof createUserUsersPost>>,
        TError,
        {data: CreateUserRequest},
        TContext
      > => {

      const mutationOptions = getCreateUserUsersPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Assign roles to a user. org_admin can only assign from the allowed set.
Admin can assign any role.
 * @summary Assign User Roles
 */
export const assignUserRolesUsersUsernameRolesPut = (
    username: string,
    userRolesRequest: UserRolesRequest,
 ) => {
      
      
      return customInstance<unknown>(
      {url: `/users/${username}/roles`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userRolesRequest
    },
      );
    }
  


export const getAssignUserRolesUsersUsernameRolesPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignUserRolesUsersUsernameRolesPut>>, TError,{username: string;data: UserRolesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof assignUserRolesUsersUsernameRolesPut>>, TError,{username: string;data: UserRolesRequest}, TContext> => {
    
const mutationKey = ['assignUserRolesUsersUsernameRolesPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignUserRolesUsersUsernameRolesPut>>, {username: string;data: UserRolesRequest}> = (props) => {
          const {username,data} = props ?? {};

          return  assignUserRolesUsersUsernameRolesPut(username,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssignUserRolesUsersUsernameRolesPutMutationResult = NonNullable<Awaited<ReturnType<typeof assignUserRolesUsersUsernameRolesPut>>>
    export type AssignUserRolesUsersUsernameRolesPutMutationBody = UserRolesRequest
    export type AssignUserRolesUsersUsernameRolesPutMutationError = HTTPValidationError

    /**
 * @summary Assign User Roles
 */
export const useAssignUserRolesUsersUsernameRolesPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignUserRolesUsersUsernameRolesPut>>, TError,{username: string;data: UserRolesRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof assignUserRolesUsersUsernameRolesPut>>,
        TError,
        {username: string;data: UserRolesRequest},
        TContext
      > => {

      const mutationOptions = getAssignUserRolesUsersUsernameRolesPutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Revoke roles from a user. org_admin can only revoke from the allowed set.
Admin can revoke any role.
 * @summary Revoke User Roles
 */
export const revokeUserRolesUsersUsernameRolesDelete = (
    username: string,
    userRolesRequest: UserRolesRequest,
 ) => {
      
      
      return customInstance<unknown>(
      {url: `/users/${username}/roles`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: userRolesRequest
    },
      );
    }
  


export const getRevokeUserRolesUsersUsernameRolesDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeUserRolesUsersUsernameRolesDelete>>, TError,{username: string;data: UserRolesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revokeUserRolesUsersUsernameRolesDelete>>, TError,{username: string;data: UserRolesRequest}, TContext> => {
    
const mutationKey = ['revokeUserRolesUsersUsernameRolesDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeUserRolesUsersUsernameRolesDelete>>, {username: string;data: UserRolesRequest}> = (props) => {
          const {username,data} = props ?? {};

          return  revokeUserRolesUsersUsernameRolesDelete(username,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RevokeUserRolesUsersUsernameRolesDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof revokeUserRolesUsersUsernameRolesDelete>>>
    export type RevokeUserRolesUsersUsernameRolesDeleteMutationBody = UserRolesRequest
    export type RevokeUserRolesUsersUsernameRolesDeleteMutationError = HTTPValidationError

    /**
 * @summary Revoke User Roles
 */
export const useRevokeUserRolesUsersUsernameRolesDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeUserRolesUsersUsernameRolesDelete>>, TError,{username: string;data: UserRolesRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof revokeUserRolesUsersUsernameRolesDelete>>,
        TError,
        {username: string;data: UserRolesRequest},
        TContext
      > => {

      const mutationOptions = getRevokeUserRolesUsersUsernameRolesDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Change a user's password. Available to admin and org_admin.
Password is set as permanent (no SMTP for temp password flow).
 * @summary Change User Password
 */
export const changeUserPasswordUsersUsernamePasswordPut = (
    username: string,
    userPasswordRequest: UserPasswordRequest,
 ) => {
      
      
      return customInstance<unknown>(
      {url: `/users/${username}/password`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userPasswordRequest
    },
      );
    }
  


export const getChangeUserPasswordUsersUsernamePasswordPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeUserPasswordUsersUsernamePasswordPut>>, TError,{username: string;data: UserPasswordRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof changeUserPasswordUsersUsernamePasswordPut>>, TError,{username: string;data: UserPasswordRequest}, TContext> => {
    
const mutationKey = ['changeUserPasswordUsersUsernamePasswordPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeUserPasswordUsersUsernamePasswordPut>>, {username: string;data: UserPasswordRequest}> = (props) => {
          const {username,data} = props ?? {};

          return  changeUserPasswordUsersUsernamePasswordPut(username,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeUserPasswordUsersUsernamePasswordPutMutationResult = NonNullable<Awaited<ReturnType<typeof changeUserPasswordUsersUsernamePasswordPut>>>
    export type ChangeUserPasswordUsersUsernamePasswordPutMutationBody = UserPasswordRequest
    export type ChangeUserPasswordUsersUsernamePasswordPutMutationError = HTTPValidationError

    /**
 * @summary Change User Password
 */
export const useChangeUserPasswordUsersUsernamePasswordPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeUserPasswordUsersUsernamePasswordPut>>, TError,{username: string;data: UserPasswordRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof changeUserPasswordUsersUsernamePasswordPut>>,
        TError,
        {username: string;data: UserPasswordRequest},
        TContext
      > => {

      const mutationOptions = getChangeUserPasswordUsersUsernamePasswordPutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * GET request endpoint to login via browser

:param redirect_uri: the url where you want to be redirected to after logging in
 * @summary Login
 */
export const loginAuthenticationLoginGet = (
    params: LoginAuthenticationLoginGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/authentication/login`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getLoginAuthenticationLoginGetQueryKey = (params: LoginAuthenticationLoginGetParams,) => {
    return [`/authentication/login`, ...(params ? [params]: [])] as const;
    }

    
export const getLoginAuthenticationLoginGetQueryOptions = <TData = Awaited<ReturnType<typeof loginAuthenticationLoginGet>>, TError = HTTPValidationError>(params: LoginAuthenticationLoginGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginAuthenticationLoginGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoginAuthenticationLoginGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof loginAuthenticationLoginGet>>> = ({ signal }) => loginAuthenticationLoginGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loginAuthenticationLoginGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LoginAuthenticationLoginGetQueryResult = NonNullable<Awaited<ReturnType<typeof loginAuthenticationLoginGet>>>
export type LoginAuthenticationLoginGetQueryError = HTTPValidationError


export function useLoginAuthenticationLoginGet<TData = Awaited<ReturnType<typeof loginAuthenticationLoginGet>>, TError = HTTPValidationError>(
 params: LoginAuthenticationLoginGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginAuthenticationLoginGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginAuthenticationLoginGet>>,
          TError,
          Awaited<ReturnType<typeof loginAuthenticationLoginGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoginAuthenticationLoginGet<TData = Awaited<ReturnType<typeof loginAuthenticationLoginGet>>, TError = HTTPValidationError>(
 params: LoginAuthenticationLoginGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginAuthenticationLoginGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginAuthenticationLoginGet>>,
          TError,
          Awaited<ReturnType<typeof loginAuthenticationLoginGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoginAuthenticationLoginGet<TData = Awaited<ReturnType<typeof loginAuthenticationLoginGet>>, TError = HTTPValidationError>(
 params: LoginAuthenticationLoginGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginAuthenticationLoginGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Login
 */

export function useLoginAuthenticationLoginGet<TData = Awaited<ReturnType<typeof loginAuthenticationLoginGet>>, TError = HTTPValidationError>(
 params: LoginAuthenticationLoginGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginAuthenticationLoginGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLoginAuthenticationLoginGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * POST request login via some non-browser interface (Postman, code, etc.)

:param username: Oauth2 username
:param password: Oauth2 password
 * @summary Programmatic Login
 */
export const programmaticLoginAuthenticationProgrammaticLoginPost = (
    bodyProgrammaticLoginAuthenticationProgrammaticLoginPost: BodyProgrammaticLoginAuthenticationProgrammaticLoginPost,
 signal?: AbortSignal
) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('username', bodyProgrammaticLoginAuthenticationProgrammaticLoginPost.username)
formUrlEncoded.append('password', bodyProgrammaticLoginAuthenticationProgrammaticLoginPost.password)

      return customInstance<MessageResponse>(
      {url: `/authentication/programmatic-login`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded, signal
    },
      );
    }
  


export const getProgrammaticLoginAuthenticationProgrammaticLoginPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof programmaticLoginAuthenticationProgrammaticLoginPost>>, TError,{data: BodyProgrammaticLoginAuthenticationProgrammaticLoginPost}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof programmaticLoginAuthenticationProgrammaticLoginPost>>, TError,{data: BodyProgrammaticLoginAuthenticationProgrammaticLoginPost}, TContext> => {
    
const mutationKey = ['programmaticLoginAuthenticationProgrammaticLoginPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof programmaticLoginAuthenticationProgrammaticLoginPost>>, {data: BodyProgrammaticLoginAuthenticationProgrammaticLoginPost}> = (props) => {
          const {data} = props ?? {};

          return  programmaticLoginAuthenticationProgrammaticLoginPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProgrammaticLoginAuthenticationProgrammaticLoginPostMutationResult = NonNullable<Awaited<ReturnType<typeof programmaticLoginAuthenticationProgrammaticLoginPost>>>
    export type ProgrammaticLoginAuthenticationProgrammaticLoginPostMutationBody = BodyProgrammaticLoginAuthenticationProgrammaticLoginPost
    export type ProgrammaticLoginAuthenticationProgrammaticLoginPostMutationError = HTTPValidationError

    /**
 * @summary Programmatic Login
 */
export const useProgrammaticLoginAuthenticationProgrammaticLoginPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof programmaticLoginAuthenticationProgrammaticLoginPost>>, TError,{data: BodyProgrammaticLoginAuthenticationProgrammaticLoginPost}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof programmaticLoginAuthenticationProgrammaticLoginPost>>,
        TError,
        {data: BodyProgrammaticLoginAuthenticationProgrammaticLoginPost},
        TContext
      > => {

      const mutationOptions = getProgrammaticLoginAuthenticationProgrammaticLoginPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * GET request to handle the callback endpoint called by
Keycloak during a login via browser interface.
 * @summary Callback
 */
export const callbackAuthenticationCallbackGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/authentication/callback`, method: 'GET', signal
    },
      );
    }
  

export const getCallbackAuthenticationCallbackGetQueryKey = () => {
    return [`/authentication/callback`] as const;
    }

    
export const getCallbackAuthenticationCallbackGetQueryOptions = <TData = Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCallbackAuthenticationCallbackGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>> = ({ signal }) => callbackAuthenticationCallbackGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CallbackAuthenticationCallbackGetQueryResult = NonNullable<Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>>
export type CallbackAuthenticationCallbackGetQueryError = unknown


export function useCallbackAuthenticationCallbackGet<TData = Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>,
          TError,
          Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCallbackAuthenticationCallbackGet<TData = Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>,
          TError,
          Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCallbackAuthenticationCallbackGet<TData = Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Callback
 */

export function useCallbackAuthenticationCallbackGet<TData = Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callbackAuthenticationCallbackGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCallbackAuthenticationCallbackGetQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * POST request to logout.
 * @summary Logout
 */
export const logoutAuthenticationLogoutPost = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<MessageResponse>(
      {url: `/authentication/logout`, method: 'POST', signal
    },
      );
    }
  


export const getLogoutAuthenticationLogoutPostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutAuthenticationLogoutPost>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof logoutAuthenticationLogoutPost>>, TError,void, TContext> => {
    
const mutationKey = ['logoutAuthenticationLogoutPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutAuthenticationLogoutPost>>, void> = () => {
          

          return  logoutAuthenticationLogoutPost()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutAuthenticationLogoutPostMutationResult = NonNullable<Awaited<ReturnType<typeof logoutAuthenticationLogoutPost>>>
    
    export type LogoutAuthenticationLogoutPostMutationError = unknown

    /**
 * @summary Logout
 */
export const useLogoutAuthenticationLogoutPost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutAuthenticationLogoutPost>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof logoutAuthenticationLogoutPost>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getLogoutAuthenticationLogoutPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Change User Password
 */
export const changeUserPasswordAuthenticationProtectedChangePasswordPost = (
    bodyChangeUserPasswordAuthenticationProtectedChangePasswordPost: BodyChangeUserPasswordAuthenticationProtectedChangePasswordPost,
 signal?: AbortSignal
) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('new_password', bodyChangeUserPasswordAuthenticationProtectedChangePasswordPost.new_password)

      return customInstance<unknown>(
      {url: `/authentication-protected/change-password`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded, signal
    },
      );
    }
  


export const getChangeUserPasswordAuthenticationProtectedChangePasswordPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeUserPasswordAuthenticationProtectedChangePasswordPost>>, TError,{data: BodyChangeUserPasswordAuthenticationProtectedChangePasswordPost}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof changeUserPasswordAuthenticationProtectedChangePasswordPost>>, TError,{data: BodyChangeUserPasswordAuthenticationProtectedChangePasswordPost}, TContext> => {
    
const mutationKey = ['changeUserPasswordAuthenticationProtectedChangePasswordPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeUserPasswordAuthenticationProtectedChangePasswordPost>>, {data: BodyChangeUserPasswordAuthenticationProtectedChangePasswordPost}> = (props) => {
          const {data} = props ?? {};

          return  changeUserPasswordAuthenticationProtectedChangePasswordPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeUserPasswordAuthenticationProtectedChangePasswordPostMutationResult = NonNullable<Awaited<ReturnType<typeof changeUserPasswordAuthenticationProtectedChangePasswordPost>>>
    export type ChangeUserPasswordAuthenticationProtectedChangePasswordPostMutationBody = BodyChangeUserPasswordAuthenticationProtectedChangePasswordPost
    export type ChangeUserPasswordAuthenticationProtectedChangePasswordPostMutationError = HTTPValidationError

    /**
 * @summary Change User Password
 */
export const useChangeUserPasswordAuthenticationProtectedChangePasswordPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeUserPasswordAuthenticationProtectedChangePasswordPost>>, TError,{data: BodyChangeUserPasswordAuthenticationProtectedChangePasswordPost}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof changeUserPasswordAuthenticationProtectedChangePasswordPost>>,
        TError,
        {data: BodyChangeUserPasswordAuthenticationProtectedChangePasswordPost},
        TContext
      > => {

      const mutationOptions = getChangeUserPasswordAuthenticationProtectedChangePasswordPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Returns Available roles for this API
 * @summary Get Ac Roles
 */
export const getAcRolesAuthenticationProtectedRolesGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/authentication-protected/roles`, method: 'GET', signal
    },
      );
    }
  

export const getGetAcRolesAuthenticationProtectedRolesGetQueryKey = () => {
    return [`/authentication-protected/roles`] as const;
    }

    
export const getGetAcRolesAuthenticationProtectedRolesGetQueryOptions = <TData = Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAcRolesAuthenticationProtectedRolesGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>> = ({ signal }) => getAcRolesAuthenticationProtectedRolesGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAcRolesAuthenticationProtectedRolesGetQueryResult = NonNullable<Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>>
export type GetAcRolesAuthenticationProtectedRolesGetQueryError = unknown


export function useGetAcRolesAuthenticationProtectedRolesGet<TData = Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>,
          TError,
          Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAcRolesAuthenticationProtectedRolesGet<TData = Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>,
          TError,
          Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAcRolesAuthenticationProtectedRolesGet<TData = Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Ac Roles
 */

export function useGetAcRolesAuthenticationProtectedRolesGet<TData = Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAcRolesAuthenticationProtectedRolesGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAcRolesAuthenticationProtectedRolesGetQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get list of data_files (metadata ONLY)
 * @summary Get Data Files
 */
export const getDataFilesDataFileGet = (
    params?: GetDataFilesDataFileGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetDataFilesDataFileGet200>(
      {url: `/data_file/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetDataFilesDataFileGetQueryKey = (params?: GetDataFilesDataFileGetParams,) => {
    return [`/data_file/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDataFilesDataFileGetQueryOptions = <TData = Awaited<ReturnType<typeof getDataFilesDataFileGet>>, TError = HTTPValidationError>(params?: GetDataFilesDataFileGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFilesDataFileGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataFilesDataFileGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataFilesDataFileGet>>> = ({ signal }) => getDataFilesDataFileGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataFilesDataFileGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataFilesDataFileGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDataFilesDataFileGet>>>
export type GetDataFilesDataFileGetQueryError = HTTPValidationError


export function useGetDataFilesDataFileGet<TData = Awaited<ReturnType<typeof getDataFilesDataFileGet>>, TError = HTTPValidationError>(
 params: undefined |  GetDataFilesDataFileGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFilesDataFileGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataFilesDataFileGet>>,
          TError,
          Awaited<ReturnType<typeof getDataFilesDataFileGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataFilesDataFileGet<TData = Awaited<ReturnType<typeof getDataFilesDataFileGet>>, TError = HTTPValidationError>(
 params?: GetDataFilesDataFileGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFilesDataFileGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataFilesDataFileGet>>,
          TError,
          Awaited<ReturnType<typeof getDataFilesDataFileGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataFilesDataFileGet<TData = Awaited<ReturnType<typeof getDataFilesDataFileGet>>, TError = HTTPValidationError>(
 params?: GetDataFilesDataFileGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFilesDataFileGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Data Files
 */

export function useGetDataFilesDataFileGet<TData = Awaited<ReturnType<typeof getDataFilesDataFileGet>>, TError = HTTPValidationError>(
 params?: GetDataFilesDataFileGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFilesDataFileGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataFilesDataFileGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get list of data_files (metadata ONLY)
 * @summary Get Data Files Count
 */
export const getDataFilesCountDataFileCountGet = (
    params?: GetDataFilesCountDataFileCountGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/data_file/count`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetDataFilesCountDataFileCountGetQueryKey = (params?: GetDataFilesCountDataFileCountGetParams,) => {
    return [`/data_file/count`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDataFilesCountDataFileCountGetQueryOptions = <TData = Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>, TError = HTTPValidationError>(params?: GetDataFilesCountDataFileCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataFilesCountDataFileCountGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>> = ({ signal }) => getDataFilesCountDataFileCountGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataFilesCountDataFileCountGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>>
export type GetDataFilesCountDataFileCountGetQueryError = HTTPValidationError


export function useGetDataFilesCountDataFileCountGet<TData = Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>, TError = HTTPValidationError>(
 params: undefined |  GetDataFilesCountDataFileCountGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>,
          TError,
          Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataFilesCountDataFileCountGet<TData = Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>, TError = HTTPValidationError>(
 params?: GetDataFilesCountDataFileCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>,
          TError,
          Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataFilesCountDataFileCountGet<TData = Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>, TError = HTTPValidationError>(
 params?: GetDataFilesCountDataFileCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Data Files Count
 */

export function useGetDataFilesCountDataFileCountGet<TData = Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>, TError = HTTPValidationError>(
 params?: GetDataFilesCountDataFileCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFilesCountDataFileCountGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataFilesCountDataFileCountGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the tags of Data Files.
 * @summary Get Data File Tags
 */
export const getDataFileTagsDataFileTagsGet = (
    params?: GetDataFileTagsDataFileTagsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/data_file/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetDataFileTagsDataFileTagsGetQueryKey = (params?: GetDataFileTagsDataFileTagsGetParams,) => {
    return [`/data_file/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDataFileTagsDataFileTagsGetQueryOptions = <TData = Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>, TError = HTTPValidationError>(params?: GetDataFileTagsDataFileTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataFileTagsDataFileTagsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>> = ({ signal }) => getDataFileTagsDataFileTagsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataFileTagsDataFileTagsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>>
export type GetDataFileTagsDataFileTagsGetQueryError = HTTPValidationError


export function useGetDataFileTagsDataFileTagsGet<TData = Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetDataFileTagsDataFileTagsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataFileTagsDataFileTagsGet<TData = Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>, TError = HTTPValidationError>(
 params?: GetDataFileTagsDataFileTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataFileTagsDataFileTagsGet<TData = Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>, TError = HTTPValidationError>(
 params?: GetDataFileTagsDataFileTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Data File Tags
 */

export function useGetDataFileTagsDataFileTagsGet<TData = Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>, TError = HTTPValidationError>(
 params?: GetDataFileTagsDataFileTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFileTagsDataFileTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataFileTagsDataFileTagsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get dependency tree of descendants of datafile.
 * @summary Get Data File Tree
 */
export const getDataFileTreeDataFileTreeDataFileHashGet = (
    dataFileHash: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/data_file/tree/${dataFileHash}`, method: 'GET', signal
    },
      );
    }
  

export const getGetDataFileTreeDataFileTreeDataFileHashGetQueryKey = (dataFileHash: string,) => {
    return [`/data_file/tree/${dataFileHash}`] as const;
    }

    
export const getGetDataFileTreeDataFileTreeDataFileHashGetQueryOptions = <TData = Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>, TError = HTTPValidationError>(dataFileHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataFileTreeDataFileTreeDataFileHashGetQueryKey(dataFileHash);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>> = ({ signal }) => getDataFileTreeDataFileTreeDataFileHashGet(dataFileHash, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(dataFileHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataFileTreeDataFileTreeDataFileHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>>
export type GetDataFileTreeDataFileTreeDataFileHashGetQueryError = HTTPValidationError


export function useGetDataFileTreeDataFileTreeDataFileHashGet<TData = Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>, TError = HTTPValidationError>(
 dataFileHash: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>,
          TError,
          Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataFileTreeDataFileTreeDataFileHashGet<TData = Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>, TError = HTTPValidationError>(
 dataFileHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>,
          TError,
          Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataFileTreeDataFileTreeDataFileHashGet<TData = Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>, TError = HTTPValidationError>(
 dataFileHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Data File Tree
 */

export function useGetDataFileTreeDataFileTreeDataFileHashGet<TData = Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>, TError = HTTPValidationError>(
 dataFileHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFileTreeDataFileTreeDataFileHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataFileTreeDataFileTreeDataFileHashGetQueryOptions(dataFileHash,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the dataframe of the data_file with the
given data_file_hash

:param data_file_hash: the file_hash of the data_file
 * @summary Get Data File Dataframe
 */
export const getDataFileDataframeDataFileDataframeDataFileHashGet = (
    dataFileHash: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/data_file/dataframe/${dataFileHash}`, method: 'GET', signal
    },
      );
    }
  

export const getGetDataFileDataframeDataFileDataframeDataFileHashGetQueryKey = (dataFileHash: string,) => {
    return [`/data_file/dataframe/${dataFileHash}`] as const;
    }

    
export const getGetDataFileDataframeDataFileDataframeDataFileHashGetQueryOptions = <TData = Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>, TError = HTTPValidationError>(dataFileHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataFileDataframeDataFileDataframeDataFileHashGetQueryKey(dataFileHash);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>> = ({ signal }) => getDataFileDataframeDataFileDataframeDataFileHashGet(dataFileHash, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(dataFileHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataFileDataframeDataFileDataframeDataFileHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>>
export type GetDataFileDataframeDataFileDataframeDataFileHashGetQueryError = HTTPValidationError


export function useGetDataFileDataframeDataFileDataframeDataFileHashGet<TData = Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>, TError = HTTPValidationError>(
 dataFileHash: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>,
          TError,
          Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataFileDataframeDataFileDataframeDataFileHashGet<TData = Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>, TError = HTTPValidationError>(
 dataFileHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>,
          TError,
          Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataFileDataframeDataFileDataframeDataFileHashGet<TData = Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>, TError = HTTPValidationError>(
 dataFileHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Data File Dataframe
 */

export function useGetDataFileDataframeDataFileDataframeDataFileHashGet<TData = Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>, TError = HTTPValidationError>(
 dataFileHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataFileDataframeDataFileDataframeDataFileHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataFileDataframeDataFileDataframeDataFileHashGetQueryOptions(dataFileHash,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * POST request to upload a data_file.

:param uploaded_file: binary of the file to upload. 
:param metadata: metadata for data_file
 * @summary Upload Data File
 */
export const uploadDataFileDataFileUploadPost = (
    bodyUploadDataFileDataFileUploadPost: BodyUploadDataFileDataFileUploadPost,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append('uploaded_file', bodyUploadDataFileDataFileUploadPost.uploaded_file)
formData.append('metadata', JSON.stringify(bodyUploadDataFileDataFileUploadPost.metadata));

      return customInstance<UploadDataFileResponse>(
      {url: `/data_file/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadDataFileDataFileUploadPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDataFileDataFileUploadPost>>, TError,{data: BodyUploadDataFileDataFileUploadPost}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadDataFileDataFileUploadPost>>, TError,{data: BodyUploadDataFileDataFileUploadPost}, TContext> => {
    
const mutationKey = ['uploadDataFileDataFileUploadPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadDataFileDataFileUploadPost>>, {data: BodyUploadDataFileDataFileUploadPost}> = (props) => {
          const {data} = props ?? {};

          return  uploadDataFileDataFileUploadPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadDataFileDataFileUploadPostMutationResult = NonNullable<Awaited<ReturnType<typeof uploadDataFileDataFileUploadPost>>>
    export type UploadDataFileDataFileUploadPostMutationBody = BodyUploadDataFileDataFileUploadPost
    export type UploadDataFileDataFileUploadPostMutationError = HTTPValidationError

    /**
 * @summary Upload Data File
 */
export const useUploadDataFileDataFileUploadPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDataFileDataFileUploadPost>>, TError,{data: BodyUploadDataFileDataFileUploadPost}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof uploadDataFileDataFileUploadPost>>,
        TError,
        {data: BodyUploadDataFileDataFileUploadPost},
        TContext
      > => {

      const mutationOptions = getUploadDataFileDataFileUploadPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * POST request to update a data_file.

:param data_file_hash: file_hash of the data_file to update. 
:param metadata: metadata for data_file
 * @summary Update Data File
 */
export const updateDataFileDataFileUpdateDataFileHashPut = (
    dataFileHash: string,
    updateDataFileRequest: UpdateDataFileRequest,
 ) => {
      
      
      return customInstance<MessageResponse>(
      {url: `/data_file/update/${dataFileHash}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDataFileRequest
    },
      );
    }
  


export const getUpdateDataFileDataFileUpdateDataFileHashPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDataFileDataFileUpdateDataFileHashPut>>, TError,{dataFileHash: string;data: UpdateDataFileRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateDataFileDataFileUpdateDataFileHashPut>>, TError,{dataFileHash: string;data: UpdateDataFileRequest}, TContext> => {
    
const mutationKey = ['updateDataFileDataFileUpdateDataFileHashPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDataFileDataFileUpdateDataFileHashPut>>, {dataFileHash: string;data: UpdateDataFileRequest}> = (props) => {
          const {dataFileHash,data} = props ?? {};

          return  updateDataFileDataFileUpdateDataFileHashPut(dataFileHash,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDataFileDataFileUpdateDataFileHashPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateDataFileDataFileUpdateDataFileHashPut>>>
    export type UpdateDataFileDataFileUpdateDataFileHashPutMutationBody = UpdateDataFileRequest
    export type UpdateDataFileDataFileUpdateDataFileHashPutMutationError = HTTPValidationError

    /**
 * @summary Update Data File
 */
export const useUpdateDataFileDataFileUpdateDataFileHashPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDataFileDataFileUpdateDataFileHashPut>>, TError,{dataFileHash: string;data: UpdateDataFileRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof updateDataFileDataFileUpdateDataFileHashPut>>,
        TError,
        {dataFileHash: string;data: UpdateDataFileRequest},
        TContext
      > => {

      const mutationOptions = getUpdateDataFileDataFileUpdateDataFileHashPutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * DELETE request for data_file
 * @summary Delete Data File
 */
export const deleteDataFileDataFileDataFileHashDelete = (
    dataFileHash: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/data_file/${dataFileHash}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteDataFileDataFileDataFileHashDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDataFileDataFileDataFileHashDelete>>, TError,{dataFileHash: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDataFileDataFileDataFileHashDelete>>, TError,{dataFileHash: string}, TContext> => {
    
const mutationKey = ['deleteDataFileDataFileDataFileHashDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDataFileDataFileDataFileHashDelete>>, {dataFileHash: string}> = (props) => {
          const {dataFileHash} = props ?? {};

          return  deleteDataFileDataFileDataFileHashDelete(dataFileHash,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDataFileDataFileDataFileHashDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDataFileDataFileDataFileHashDelete>>>
    
    export type DeleteDataFileDataFileDataFileHashDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete Data File
 */
export const useDeleteDataFileDataFileDataFileHashDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDataFileDataFileDataFileHashDelete>>, TError,{dataFileHash: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteDataFileDataFileDataFileHashDelete>>,
        TError,
        {dataFileHash: string},
        TContext
      > => {

      const mutationOptions = getDeleteDataFileDataFileDataFileHashDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * GET request to download a data file
 * @summary Download Data File
 */
export const downloadDataFileDataFileDownloadDataFileHashGet = (
    dataFileHash: string,
    params?: DownloadDataFileDataFileDownloadDataFileHashGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/data_file/download/${dataFileHash}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getDownloadDataFileDataFileDownloadDataFileHashGetQueryKey = (dataFileHash: string,
    params?: DownloadDataFileDataFileDownloadDataFileHashGetParams,) => {
    return [`/data_file/download/${dataFileHash}`, ...(params ? [params]: [])] as const;
    }

    
export const getDownloadDataFileDataFileDownloadDataFileHashGetQueryOptions = <TData = Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>, TError = HTTPValidationError>(dataFileHash: string,
    params?: DownloadDataFileDataFileDownloadDataFileHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadDataFileDataFileDownloadDataFileHashGetQueryKey(dataFileHash,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>> = ({ signal }) => downloadDataFileDataFileDownloadDataFileHashGet(dataFileHash,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(dataFileHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadDataFileDataFileDownloadDataFileHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>>
export type DownloadDataFileDataFileDownloadDataFileHashGetQueryError = HTTPValidationError


export function useDownloadDataFileDataFileDownloadDataFileHashGet<TData = Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>, TError = HTTPValidationError>(
 dataFileHash: string,
    params: undefined |  DownloadDataFileDataFileDownloadDataFileHashGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>,
          TError,
          Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDataFileDataFileDownloadDataFileHashGet<TData = Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>, TError = HTTPValidationError>(
 dataFileHash: string,
    params?: DownloadDataFileDataFileDownloadDataFileHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>,
          TError,
          Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDataFileDataFileDownloadDataFileHashGet<TData = Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>, TError = HTTPValidationError>(
 dataFileHash: string,
    params?: DownloadDataFileDataFileDownloadDataFileHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download Data File
 */

export function useDownloadDataFileDataFileDownloadDataFileHashGet<TData = Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>, TError = HTTPValidationError>(
 dataFileHash: string,
    params?: DownloadDataFileDataFileDownloadDataFileHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDataFileDataFileDownloadDataFileHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadDataFileDataFileDownloadDataFileHashGetQueryOptions(dataFileHash,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get list of datasets (metadata ONLY)
 * @summary Get Datasets
 */
export const getDatasetsDatasetGet = (
    params?: GetDatasetsDatasetGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetDatasetsDatasetGet200>(
      {url: `/dataset/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetDatasetsDatasetGetQueryKey = (params?: GetDatasetsDatasetGetParams,) => {
    return [`/dataset/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDatasetsDatasetGetQueryOptions = <TData = Awaited<ReturnType<typeof getDatasetsDatasetGet>>, TError = HTTPValidationError>(params?: GetDatasetsDatasetGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetsDatasetGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatasetsDatasetGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatasetsDatasetGet>>> = ({ signal }) => getDatasetsDatasetGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatasetsDatasetGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatasetsDatasetGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDatasetsDatasetGet>>>
export type GetDatasetsDatasetGetQueryError = HTTPValidationError


export function useGetDatasetsDatasetGet<TData = Awaited<ReturnType<typeof getDatasetsDatasetGet>>, TError = HTTPValidationError>(
 params: undefined |  GetDatasetsDatasetGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetsDatasetGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetsDatasetGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetsDatasetGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetsDatasetGet<TData = Awaited<ReturnType<typeof getDatasetsDatasetGet>>, TError = HTTPValidationError>(
 params?: GetDatasetsDatasetGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetsDatasetGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetsDatasetGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetsDatasetGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetsDatasetGet<TData = Awaited<ReturnType<typeof getDatasetsDatasetGet>>, TError = HTTPValidationError>(
 params?: GetDatasetsDatasetGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetsDatasetGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Datasets
 */

export function useGetDatasetsDatasetGet<TData = Awaited<ReturnType<typeof getDatasetsDatasetGet>>, TError = HTTPValidationError>(
 params?: GetDatasetsDatasetGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetsDatasetGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatasetsDatasetGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET all versions of a dataset group identified by (owner, name).
Returns all datasets matching the owner+name combination, sorted by creation_date desc by default.
 * @summary Get Dataset Versions
 */
export const getDatasetVersionsDatasetVersionsGet = (
    params: GetDatasetVersionsDatasetVersionsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DatasetListResponse>(
      {url: `/dataset/versions`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetDatasetVersionsDatasetVersionsGetQueryKey = (params: GetDatasetVersionsDatasetVersionsGetParams,) => {
    return [`/dataset/versions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDatasetVersionsDatasetVersionsGetQueryOptions = <TData = Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>, TError = HTTPValidationError>(params: GetDatasetVersionsDatasetVersionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatasetVersionsDatasetVersionsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>> = ({ signal }) => getDatasetVersionsDatasetVersionsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatasetVersionsDatasetVersionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>>
export type GetDatasetVersionsDatasetVersionsGetQueryError = HTTPValidationError


export function useGetDatasetVersionsDatasetVersionsGet<TData = Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>, TError = HTTPValidationError>(
 params: GetDatasetVersionsDatasetVersionsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetVersionsDatasetVersionsGet<TData = Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>, TError = HTTPValidationError>(
 params: GetDatasetVersionsDatasetVersionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetVersionsDatasetVersionsGet<TData = Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>, TError = HTTPValidationError>(
 params: GetDatasetVersionsDatasetVersionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Dataset Versions
 */

export function useGetDatasetVersionsDatasetVersionsGet<TData = Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>, TError = HTTPValidationError>(
 params: GetDatasetVersionsDatasetVersionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetVersionsDatasetVersionsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatasetVersionsDatasetVersionsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get list of datasets (metadata ONLY)
 * @deprecated
 * @summary Get Datasets Count
 */
export const getDatasetsCountDatasetCountGet = (
    params?: GetDatasetsCountDatasetCountGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/dataset/count`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetDatasetsCountDatasetCountGetQueryKey = (params?: GetDatasetsCountDatasetCountGetParams,) => {
    return [`/dataset/count`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDatasetsCountDatasetCountGetQueryOptions = <TData = Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>, TError = HTTPValidationError>(params?: GetDatasetsCountDatasetCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatasetsCountDatasetCountGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>> = ({ signal }) => getDatasetsCountDatasetCountGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatasetsCountDatasetCountGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>>
export type GetDatasetsCountDatasetCountGetQueryError = HTTPValidationError


export function useGetDatasetsCountDatasetCountGet<TData = Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>, TError = HTTPValidationError>(
 params: undefined |  GetDatasetsCountDatasetCountGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetsCountDatasetCountGet<TData = Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>, TError = HTTPValidationError>(
 params?: GetDatasetsCountDatasetCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetsCountDatasetCountGet<TData = Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>, TError = HTTPValidationError>(
 params?: GetDatasetsCountDatasetCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Get Datasets Count
 */

export function useGetDatasetsCountDatasetCountGet<TData = Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>, TError = HTTPValidationError>(
 params?: GetDatasetsCountDatasetCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetsCountDatasetCountGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatasetsCountDatasetCountGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * API endpoint to get the supported data types for columns in datasets.
 * @summary Get Supported Data Types
 */
export const getSupportedDataTypesDatasetSupportedColumnDataTypesGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/dataset/supported_column_data_types`, method: 'GET', signal
    },
      );
    }
  

export const getGetSupportedDataTypesDatasetSupportedColumnDataTypesGetQueryKey = () => {
    return [`/dataset/supported_column_data_types`] as const;
    }

    
export const getGetSupportedDataTypesDatasetSupportedColumnDataTypesGetQueryOptions = <TData = Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportedDataTypesDatasetSupportedColumnDataTypesGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>> = ({ signal }) => getSupportedDataTypesDatasetSupportedColumnDataTypesGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupportedDataTypesDatasetSupportedColumnDataTypesGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>>
export type GetSupportedDataTypesDatasetSupportedColumnDataTypesGetQueryError = unknown


export function useGetSupportedDataTypesDatasetSupportedColumnDataTypesGet<TData = Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>,
          TError,
          Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedDataTypesDatasetSupportedColumnDataTypesGet<TData = Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>,
          TError,
          Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedDataTypesDatasetSupportedColumnDataTypesGet<TData = Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Supported Data Types
 */

export function useGetSupportedDataTypesDatasetSupportedColumnDataTypesGet<TData = Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedDataTypesDatasetSupportedColumnDataTypesGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSupportedDataTypesDatasetSupportedColumnDataTypesGetQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * API endpoint to get the supported dataset types.
 * @summary Get Supported Dataset Types
 */
export const getSupportedDatasetTypesDatasetSupportedDatasetTypesGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/dataset/supported_dataset_types`, method: 'GET', signal
    },
      );
    }
  

export const getGetSupportedDatasetTypesDatasetSupportedDatasetTypesGetQueryKey = () => {
    return [`/dataset/supported_dataset_types`] as const;
    }

    
export const getGetSupportedDatasetTypesDatasetSupportedDatasetTypesGetQueryOptions = <TData = Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportedDatasetTypesDatasetSupportedDatasetTypesGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>> = ({ signal }) => getSupportedDatasetTypesDatasetSupportedDatasetTypesGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupportedDatasetTypesDatasetSupportedDatasetTypesGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>>
export type GetSupportedDatasetTypesDatasetSupportedDatasetTypesGetQueryError = unknown


export function useGetSupportedDatasetTypesDatasetSupportedDatasetTypesGet<TData = Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>,
          TError,
          Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedDatasetTypesDatasetSupportedDatasetTypesGet<TData = Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>,
          TError,
          Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedDatasetTypesDatasetSupportedDatasetTypesGet<TData = Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Supported Dataset Types
 */

export function useGetSupportedDatasetTypesDatasetSupportedDatasetTypesGet<TData = Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedDatasetTypesDatasetSupportedDatasetTypesGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSupportedDatasetTypesDatasetSupportedDatasetTypesGetQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the tags of Datasets.
 * @summary Get Dataset Tags
 */
export const getDatasetTagsDatasetTagsGet = (
    params?: GetDatasetTagsDatasetTagsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/dataset/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetDatasetTagsDatasetTagsGetQueryKey = (params?: GetDatasetTagsDatasetTagsGetParams,) => {
    return [`/dataset/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDatasetTagsDatasetTagsGetQueryOptions = <TData = Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>, TError = HTTPValidationError>(params?: GetDatasetTagsDatasetTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatasetTagsDatasetTagsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>> = ({ signal }) => getDatasetTagsDatasetTagsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatasetTagsDatasetTagsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>>
export type GetDatasetTagsDatasetTagsGetQueryError = HTTPValidationError


export function useGetDatasetTagsDatasetTagsGet<TData = Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetDatasetTagsDatasetTagsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetTagsDatasetTagsGet<TData = Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>, TError = HTTPValidationError>(
 params?: GetDatasetTagsDatasetTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetTagsDatasetTagsGet<TData = Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>, TError = HTTPValidationError>(
 params?: GetDatasetTagsDatasetTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Dataset Tags
 */

export function useGetDatasetTagsDatasetTagsGet<TData = Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>, TError = HTTPValidationError>(
 params?: GetDatasetTagsDatasetTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetTagsDatasetTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatasetTagsDatasetTagsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get dependency tree of descendants and parents of dataset.
 * @summary Get Dataset Tree
 */
export const getDatasetTreeDatasetTreeDatasetHashGet = (
    datasetHash: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/dataset/tree/${datasetHash}`, method: 'GET', signal
    },
      );
    }
  

export const getGetDatasetTreeDatasetTreeDatasetHashGetQueryKey = (datasetHash: string,) => {
    return [`/dataset/tree/${datasetHash}`] as const;
    }

    
export const getGetDatasetTreeDatasetTreeDatasetHashGetQueryOptions = <TData = Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>, TError = HTTPValidationError>(datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatasetTreeDatasetTreeDatasetHashGetQueryKey(datasetHash);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>> = ({ signal }) => getDatasetTreeDatasetTreeDatasetHashGet(datasetHash, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(datasetHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatasetTreeDatasetTreeDatasetHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>>
export type GetDatasetTreeDatasetTreeDatasetHashGetQueryError = HTTPValidationError


export function useGetDatasetTreeDatasetTreeDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetTreeDatasetTreeDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetTreeDatasetTreeDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Dataset Tree
 */

export function useGetDatasetTreeDatasetTreeDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetTreeDatasetTreeDatasetHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatasetTreeDatasetTreeDatasetHashGetQueryOptions(datasetHash,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get dependency tree of descendants and parents of dataset.
 * @summary Get Dataset Eclean Stages
 */
export const getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet = (
    datasetHash: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/dataset/eclean_stages/${datasetHash}`, method: 'GET', signal
    },
      );
    }
  

export const getGetDatasetEcleanStagesDatasetEcleanStagesDatasetHashGetQueryKey = (datasetHash: string,) => {
    return [`/dataset/eclean_stages/${datasetHash}`] as const;
    }

    
export const getGetDatasetEcleanStagesDatasetEcleanStagesDatasetHashGetQueryOptions = <TData = Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>, TError = HTTPValidationError>(datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatasetEcleanStagesDatasetEcleanStagesDatasetHashGetQueryKey(datasetHash);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>> = ({ signal }) => getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet(datasetHash, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(datasetHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatasetEcleanStagesDatasetEcleanStagesDatasetHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>>
export type GetDatasetEcleanStagesDatasetEcleanStagesDatasetHashGetQueryError = HTTPValidationError


export function useGetDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Dataset Eclean Stages
 */

export function useGetDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetEcleanStagesDatasetEcleanStagesDatasetHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatasetEcleanStagesDatasetEcleanStagesDatasetHashGetQueryOptions(datasetHash,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the dataframe of the dataset with the
given dataset_hash

:param dataset_hash: the file_hash of the dataset
:param applicability_domain: Query parameter boolean to also join Applicability Domain results
 * @summary Get Dataset Dataframe
 */
export const getDatasetDataframeDatasetDataframeDatasetHashGet = (
    datasetHash: string,
    params?: GetDatasetDataframeDatasetDataframeDatasetHashGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/dataset/dataframe/${datasetHash}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetDatasetDataframeDatasetDataframeDatasetHashGetQueryKey = (datasetHash: string,
    params?: GetDatasetDataframeDatasetDataframeDatasetHashGetParams,) => {
    return [`/dataset/dataframe/${datasetHash}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDatasetDataframeDatasetDataframeDatasetHashGetQueryOptions = <TData = Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>, TError = HTTPValidationError>(datasetHash: string,
    params?: GetDatasetDataframeDatasetDataframeDatasetHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatasetDataframeDatasetDataframeDatasetHashGetQueryKey(datasetHash,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>> = ({ signal }) => getDatasetDataframeDatasetDataframeDatasetHashGet(datasetHash,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(datasetHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatasetDataframeDatasetDataframeDatasetHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>>
export type GetDatasetDataframeDatasetDataframeDatasetHashGetQueryError = HTTPValidationError


export function useGetDatasetDataframeDatasetDataframeDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string,
    params: undefined |  GetDatasetDataframeDatasetDataframeDatasetHashGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetDataframeDatasetDataframeDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string,
    params?: GetDatasetDataframeDatasetDataframeDatasetHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetDataframeDatasetDataframeDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string,
    params?: GetDatasetDataframeDatasetDataframeDatasetHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Dataset Dataframe
 */

export function useGetDatasetDataframeDatasetDataframeDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string,
    params?: GetDatasetDataframeDatasetDataframeDatasetHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetDataframeDatasetDataframeDatasetHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatasetDataframeDatasetDataframeDatasetHashGetQueryOptions(datasetHash,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the protocol of the dataset with the
given dataset_hash

:param dataset_hash: the file_hash of the dataset
 * @summary Get Dataset Protocol
 */
export const getDatasetProtocolDatasetProtocolDatasetHashGet = (
    datasetHash: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetDatasetProtocolDatasetProtocolDatasetHashGet200>(
      {url: `/dataset/protocol/${datasetHash}`, method: 'GET', signal
    },
      );
    }
  

export const getGetDatasetProtocolDatasetProtocolDatasetHashGetQueryKey = (datasetHash: string,) => {
    return [`/dataset/protocol/${datasetHash}`] as const;
    }

    
export const getGetDatasetProtocolDatasetProtocolDatasetHashGetQueryOptions = <TData = Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>, TError = HTTPValidationError>(datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatasetProtocolDatasetProtocolDatasetHashGetQueryKey(datasetHash);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>> = ({ signal }) => getDatasetProtocolDatasetProtocolDatasetHashGet(datasetHash, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(datasetHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatasetProtocolDatasetProtocolDatasetHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>>
export type GetDatasetProtocolDatasetProtocolDatasetHashGetQueryError = HTTPValidationError


export function useGetDatasetProtocolDatasetProtocolDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetProtocolDatasetProtocolDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetProtocolDatasetProtocolDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Dataset Protocol
 */

export function useGetDatasetProtocolDatasetProtocolDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetProtocolDatasetProtocolDatasetHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatasetProtocolDatasetProtocolDatasetHashGetQueryOptions(datasetHash,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the protocol of the dataset with the
given dataset_hash

:param dataset_hash: the file_hash of the dataset
 * @summary Download Dataset Protocol
 */
export const downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet = (
    datasetHash: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/dataset/protocol_download/${datasetHash}`, method: 'GET', signal
    },
      );
    }
  

export const getDownloadDatasetProtocolDatasetProtocolDownloadDatasetHashGetQueryKey = (datasetHash: string,) => {
    return [`/dataset/protocol_download/${datasetHash}`] as const;
    }

    
export const getDownloadDatasetProtocolDatasetProtocolDownloadDatasetHashGetQueryOptions = <TData = Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>, TError = HTTPValidationError>(datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadDatasetProtocolDatasetProtocolDownloadDatasetHashGetQueryKey(datasetHash);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>> = ({ signal }) => downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet(datasetHash, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(datasetHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadDatasetProtocolDatasetProtocolDownloadDatasetHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>>
export type DownloadDatasetProtocolDatasetProtocolDownloadDatasetHashGetQueryError = HTTPValidationError


export function useDownloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet<TData = Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>,
          TError,
          Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet<TData = Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>,
          TError,
          Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet<TData = Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download Dataset Protocol
 */

export function useDownloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet<TData = Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDatasetProtocolDatasetProtocolDownloadDatasetHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadDatasetProtocolDatasetProtocolDownloadDatasetHashGetQueryOptions(datasetHash,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the protocol of the dataset with the
given dataset_hash

:param dataset_hash: the file_hash of the dataset
 * @summary Get Dataset Protocol Size
 */
export const getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet = (
    datasetHash: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/dataset/protocol_size/${datasetHash}`, method: 'GET', signal
    },
      );
    }
  

export const getGetDatasetProtocolSizeDatasetProtocolSizeDatasetHashGetQueryKey = (datasetHash: string,) => {
    return [`/dataset/protocol_size/${datasetHash}`] as const;
    }

    
export const getGetDatasetProtocolSizeDatasetProtocolSizeDatasetHashGetQueryOptions = <TData = Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>, TError = HTTPValidationError>(datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatasetProtocolSizeDatasetProtocolSizeDatasetHashGetQueryKey(datasetHash);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>> = ({ signal }) => getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet(datasetHash, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(datasetHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatasetProtocolSizeDatasetProtocolSizeDatasetHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>>
export type GetDatasetProtocolSizeDatasetProtocolSizeDatasetHashGetQueryError = HTTPValidationError


export function useGetDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Dataset Protocol Size
 */

export function useGetDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet<TData = Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetProtocolSizeDatasetProtocolSizeDatasetHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatasetProtocolSizeDatasetProtocolSizeDatasetHashGetQueryOptions(datasetHash,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * POST request to upload a dataset.

:param uploaded_file: binary of the file to upload. 
:param metadata: metadata for dataset
 * @summary Upload Dataset
 */
export const uploadDatasetDatasetUploadPost = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UploadDatasetResponse>(
      {url: `/dataset/upload`, method: 'POST', signal
    },
      );
    }
  


export const getUploadDatasetDatasetUploadPostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDatasetDatasetUploadPost>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadDatasetDatasetUploadPost>>, TError,void, TContext> => {
    
const mutationKey = ['uploadDatasetDatasetUploadPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadDatasetDatasetUploadPost>>, void> = () => {
          

          return  uploadDatasetDatasetUploadPost()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadDatasetDatasetUploadPostMutationResult = NonNullable<Awaited<ReturnType<typeof uploadDatasetDatasetUploadPost>>>
    
    export type UploadDatasetDatasetUploadPostMutationError = unknown

    /**
 * @summary Upload Dataset
 */
export const useUploadDatasetDatasetUploadPost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDatasetDatasetUploadPost>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof uploadDatasetDatasetUploadPost>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getUploadDatasetDatasetUploadPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * POST request to update a dataset.

:param dataset_hash: file_hash of the dataset to update. 
:param metadata: metadata for dataset
 * @summary Update Dataset
 */
export const updateDatasetDatasetUpdateDatasetHashPut = (
    datasetHash: string,
    updateDatasetRequest: UpdateDatasetRequest,
 ) => {
      
      
      return customInstance<MessageResponse>(
      {url: `/dataset/update/${datasetHash}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDatasetRequest
    },
      );
    }
  


export const getUpdateDatasetDatasetUpdateDatasetHashPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDatasetDatasetUpdateDatasetHashPut>>, TError,{datasetHash: string;data: UpdateDatasetRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateDatasetDatasetUpdateDatasetHashPut>>, TError,{datasetHash: string;data: UpdateDatasetRequest}, TContext> => {
    
const mutationKey = ['updateDatasetDatasetUpdateDatasetHashPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDatasetDatasetUpdateDatasetHashPut>>, {datasetHash: string;data: UpdateDatasetRequest}> = (props) => {
          const {datasetHash,data} = props ?? {};

          return  updateDatasetDatasetUpdateDatasetHashPut(datasetHash,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDatasetDatasetUpdateDatasetHashPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateDatasetDatasetUpdateDatasetHashPut>>>
    export type UpdateDatasetDatasetUpdateDatasetHashPutMutationBody = UpdateDatasetRequest
    export type UpdateDatasetDatasetUpdateDatasetHashPutMutationError = HTTPValidationError

    /**
 * @summary Update Dataset
 */
export const useUpdateDatasetDatasetUpdateDatasetHashPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDatasetDatasetUpdateDatasetHashPut>>, TError,{datasetHash: string;data: UpdateDatasetRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof updateDatasetDatasetUpdateDatasetHashPut>>,
        TError,
        {datasetHash: string;data: UpdateDatasetRequest},
        TContext
      > => {

      const mutationOptions = getUpdateDatasetDatasetUpdateDatasetHashPutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Eclean Curation
 */
export const ecleanCurationDatasetEcleanCurationPost = (
    ecleanCurationDAGRequestModel: EcleanCurationDAGRequestModel,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/dataset/eclean_curation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ecleanCurationDAGRequestModel, signal
    },
      );
    }
  


export const getEcleanCurationDatasetEcleanCurationPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ecleanCurationDatasetEcleanCurationPost>>, TError,{data: EcleanCurationDAGRequestModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof ecleanCurationDatasetEcleanCurationPost>>, TError,{data: EcleanCurationDAGRequestModel}, TContext> => {
    
const mutationKey = ['ecleanCurationDatasetEcleanCurationPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ecleanCurationDatasetEcleanCurationPost>>, {data: EcleanCurationDAGRequestModel}> = (props) => {
          const {data} = props ?? {};

          return  ecleanCurationDatasetEcleanCurationPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EcleanCurationDatasetEcleanCurationPostMutationResult = NonNullable<Awaited<ReturnType<typeof ecleanCurationDatasetEcleanCurationPost>>>
    export type EcleanCurationDatasetEcleanCurationPostMutationBody = EcleanCurationDAGRequestModel
    export type EcleanCurationDatasetEcleanCurationPostMutationError = HTTPValidationError

    /**
 * @summary Eclean Curation
 */
export const useEcleanCurationDatasetEcleanCurationPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ecleanCurationDatasetEcleanCurationPost>>, TError,{data: EcleanCurationDAGRequestModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof ecleanCurationDatasetEcleanCurationPost>>,
        TError,
        {data: EcleanCurationDAGRequestModel},
        TContext
      > => {

      const mutationOptions = getEcleanCurationDatasetEcleanCurationPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * DELETE request for dataset
 * @summary Delete Dataset
 */
export const deleteDatasetDatasetDatasetHashDelete = (
    datasetHash: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/dataset/${datasetHash}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteDatasetDatasetDatasetHashDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDatasetDatasetDatasetHashDelete>>, TError,{datasetHash: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDatasetDatasetDatasetHashDelete>>, TError,{datasetHash: string}, TContext> => {
    
const mutationKey = ['deleteDatasetDatasetDatasetHashDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDatasetDatasetDatasetHashDelete>>, {datasetHash: string}> = (props) => {
          const {datasetHash} = props ?? {};

          return  deleteDatasetDatasetDatasetHashDelete(datasetHash,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDatasetDatasetDatasetHashDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDatasetDatasetDatasetHashDelete>>>
    
    export type DeleteDatasetDatasetDatasetHashDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete Dataset
 */
export const useDeleteDatasetDatasetDatasetHashDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDatasetDatasetDatasetHashDelete>>, TError,{datasetHash: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteDatasetDatasetDatasetHashDelete>>,
        TError,
        {datasetHash: string},
        TContext
      > => {

      const mutationOptions = getDeleteDatasetDatasetDatasetHashDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * GET request to download a dataset
 * @summary Download Dataset
 */
export const downloadDatasetDatasetDownloadDatasetHashGet = (
    datasetHash: string,
    params?: DownloadDatasetDatasetDownloadDatasetHashGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/dataset/download/${datasetHash}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getDownloadDatasetDatasetDownloadDatasetHashGetQueryKey = (datasetHash: string,
    params?: DownloadDatasetDatasetDownloadDatasetHashGetParams,) => {
    return [`/dataset/download/${datasetHash}`, ...(params ? [params]: [])] as const;
    }

    
export const getDownloadDatasetDatasetDownloadDatasetHashGetQueryOptions = <TData = Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>, TError = HTTPValidationError>(datasetHash: string,
    params?: DownloadDatasetDatasetDownloadDatasetHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadDatasetDatasetDownloadDatasetHashGetQueryKey(datasetHash,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>> = ({ signal }) => downloadDatasetDatasetDownloadDatasetHashGet(datasetHash,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(datasetHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadDatasetDatasetDownloadDatasetHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>>
export type DownloadDatasetDatasetDownloadDatasetHashGetQueryError = HTTPValidationError


export function useDownloadDatasetDatasetDownloadDatasetHashGet<TData = Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string,
    params: undefined |  DownloadDatasetDatasetDownloadDatasetHashGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>,
          TError,
          Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDatasetDatasetDownloadDatasetHashGet<TData = Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string,
    params?: DownloadDatasetDatasetDownloadDatasetHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>,
          TError,
          Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDatasetDatasetDownloadDatasetHashGet<TData = Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string,
    params?: DownloadDatasetDatasetDownloadDatasetHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download Dataset
 */

export function useDownloadDatasetDatasetDownloadDatasetHashGet<TData = Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>, TError = HTTPValidationError>(
 datasetHash: string,
    params?: DownloadDatasetDatasetDownloadDatasetHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDatasetDatasetDownloadDatasetHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadDatasetDatasetDownloadDatasetHashGetQueryOptions(datasetHash,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * DELETE request for dataset_visualizations
 * @summary Delete Dataset Visualization
 */
export const deleteDatasetVisualizationDatasetVisualizationDatasetVisualizationHashDelete = (
    datasetVisualizationHash: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/dataset_visualization/${datasetVisualizationHash}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteDatasetVisualizationDatasetVisualizationDatasetVisualizationHashDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDatasetVisualizationDatasetVisualizationDatasetVisualizationHashDelete>>, TError,{datasetVisualizationHash: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDatasetVisualizationDatasetVisualizationDatasetVisualizationHashDelete>>, TError,{datasetVisualizationHash: string}, TContext> => {
    
const mutationKey = ['deleteDatasetVisualizationDatasetVisualizationDatasetVisualizationHashDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDatasetVisualizationDatasetVisualizationDatasetVisualizationHashDelete>>, {datasetVisualizationHash: string}> = (props) => {
          const {datasetVisualizationHash} = props ?? {};

          return  deleteDatasetVisualizationDatasetVisualizationDatasetVisualizationHashDelete(datasetVisualizationHash,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDatasetVisualizationDatasetVisualizationDatasetVisualizationHashDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDatasetVisualizationDatasetVisualizationDatasetVisualizationHashDelete>>>
    
    export type DeleteDatasetVisualizationDatasetVisualizationDatasetVisualizationHashDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete Dataset Visualization
 */
export const useDeleteDatasetVisualizationDatasetVisualizationDatasetVisualizationHashDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDatasetVisualizationDatasetVisualizationDatasetVisualizationHashDelete>>, TError,{datasetVisualizationHash: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteDatasetVisualizationDatasetVisualizationDatasetVisualizationHashDelete>>,
        TError,
        {datasetVisualizationHash: string},
        TContext
      > => {

      const mutationOptions = getDeleteDatasetVisualizationDatasetVisualizationDatasetVisualizationHashDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieve the OOD sampling provenance pointer stored on the model metadata.
 * @summary Get Model Ood Sampling Provenance Pointer
 */
export const getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet = (
    modelHash: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/model/${modelHash}/provenance/pointer`, method: 'GET', signal
    },
      );
    }
  

export const getGetModelOodSamplingProvenancePointerModelModelHashProvenancePointerGetQueryKey = (modelHash: string,) => {
    return [`/model/${modelHash}/provenance/pointer`] as const;
    }

    
export const getGetModelOodSamplingProvenancePointerModelModelHashProvenancePointerGetQueryOptions = <TData = Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>, TError = HTTPValidationError>(modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelOodSamplingProvenancePointerModelModelHashProvenancePointerGetQueryKey(modelHash);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>> = ({ signal }) => getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet(modelHash, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(modelHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelOodSamplingProvenancePointerModelModelHashProvenancePointerGetQueryResult = NonNullable<Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>>
export type GetModelOodSamplingProvenancePointerModelModelHashProvenancePointerGetQueryError = HTTPValidationError


export function useGetModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet<TData = Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>, TError = HTTPValidationError>(
 modelHash: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>,
          TError,
          Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet<TData = Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>, TError = HTTPValidationError>(
 modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>,
          TError,
          Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet<TData = Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>, TError = HTTPValidationError>(
 modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Model Ood Sampling Provenance Pointer
 */

export function useGetModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet<TData = Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>, TError = HTTPValidationError>(
 modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelOodSamplingProvenancePointerModelModelHashProvenancePointerGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelOodSamplingProvenancePointerModelModelHashProvenancePointerGetQueryOptions(modelHash,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieve metadata-only information for the model provenance object reference.
 * @summary Head Model Ood Sampling Provenance
 */
export const headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet = (
    modelHash: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/model/${modelHash}/provenance/head`, method: 'GET', signal
    },
      );
    }
  

export const getHeadModelOodSamplingProvenanceModelModelHashProvenanceHeadGetQueryKey = (modelHash: string,) => {
    return [`/model/${modelHash}/provenance/head`] as const;
    }

    
export const getHeadModelOodSamplingProvenanceModelModelHashProvenanceHeadGetQueryOptions = <TData = Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>, TError = HTTPValidationError>(modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHeadModelOodSamplingProvenanceModelModelHashProvenanceHeadGetQueryKey(modelHash);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>> = ({ signal }) => headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet(modelHash, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(modelHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HeadModelOodSamplingProvenanceModelModelHashProvenanceHeadGetQueryResult = NonNullable<Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>>
export type HeadModelOodSamplingProvenanceModelModelHashProvenanceHeadGetQueryError = HTTPValidationError


export function useHeadModelOodSamplingProvenanceModelModelHashProvenanceHeadGet<TData = Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>, TError = HTTPValidationError>(
 modelHash: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>,
          TError,
          Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHeadModelOodSamplingProvenanceModelModelHashProvenanceHeadGet<TData = Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>, TError = HTTPValidationError>(
 modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>,
          TError,
          Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHeadModelOodSamplingProvenanceModelModelHashProvenanceHeadGet<TData = Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>, TError = HTTPValidationError>(
 modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Head Model Ood Sampling Provenance
 */

export function useHeadModelOodSamplingProvenanceModelModelHashProvenanceHeadGet<TData = Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>, TError = HTTPValidationError>(
 modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof headModelOodSamplingProvenanceModelModelHashProvenanceHeadGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHeadModelOodSamplingProvenanceModelModelHashProvenanceHeadGetQueryOptions(modelHash,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieve the full OOD sampling provenance JSON payload for the model.
 * @summary Get Model Ood Sampling Provenance Payload
 */
export const getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet = (
    modelHash: string,
    params?: GetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/model/${modelHash}/provenance/payload`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGetQueryKey = (modelHash: string,
    params?: GetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGetParams,) => {
    return [`/model/${modelHash}/provenance/payload`, ...(params ? [params]: [])] as const;
    }

    
export const getGetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGetQueryOptions = <TData = Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>, TError = HTTPValidationError>(modelHash: string,
    params?: GetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGetQueryKey(modelHash,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>> = ({ signal }) => getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet(modelHash,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(modelHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGetQueryResult = NonNullable<Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>>
export type GetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGetQueryError = HTTPValidationError


export function useGetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet<TData = Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>, TError = HTTPValidationError>(
 modelHash: string,
    params: undefined |  GetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>,
          TError,
          Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet<TData = Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>, TError = HTTPValidationError>(
 modelHash: string,
    params?: GetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>,
          TError,
          Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet<TData = Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>, TError = HTTPValidationError>(
 modelHash: string,
    params?: GetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Model Ood Sampling Provenance Payload
 */

export function useGetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet<TData = Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>, TError = HTTPValidationError>(
 modelHash: string,
    params?: GetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelOodSamplingProvenancePayloadModelModelHashProvenancePayloadGetQueryOptions(modelHash,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get list of models (metadata ONLY)
 * @summary Get Models
 */
export const getModelsModelGet = (
    params?: GetModelsModelGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetModelsModelGet200>(
      {url: `/model/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetModelsModelGetQueryKey = (params?: GetModelsModelGetParams,) => {
    return [`/model/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetModelsModelGetQueryOptions = <TData = Awaited<ReturnType<typeof getModelsModelGet>>, TError = HTTPValidationError>(params?: GetModelsModelGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelsModelGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelsModelGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelsModelGet>>> = ({ signal }) => getModelsModelGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelsModelGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelsModelGetQueryResult = NonNullable<Awaited<ReturnType<typeof getModelsModelGet>>>
export type GetModelsModelGetQueryError = HTTPValidationError


export function useGetModelsModelGet<TData = Awaited<ReturnType<typeof getModelsModelGet>>, TError = HTTPValidationError>(
 params: undefined |  GetModelsModelGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelsModelGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelsModelGet>>,
          TError,
          Awaited<ReturnType<typeof getModelsModelGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelsModelGet<TData = Awaited<ReturnType<typeof getModelsModelGet>>, TError = HTTPValidationError>(
 params?: GetModelsModelGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelsModelGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelsModelGet>>,
          TError,
          Awaited<ReturnType<typeof getModelsModelGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelsModelGet<TData = Awaited<ReturnType<typeof getModelsModelGet>>, TError = HTTPValidationError>(
 params?: GetModelsModelGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelsModelGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Models
 */

export function useGetModelsModelGet<TData = Awaited<ReturnType<typeof getModelsModelGet>>, TError = HTTPValidationError>(
 params?: GetModelsModelGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelsModelGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelsModelGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the tags of Model.
 * @summary Get Model Tags
 */
export const getModelTagsModelTagsGet = (
    params?: GetModelTagsModelTagsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/model/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetModelTagsModelTagsGetQueryKey = (params?: GetModelTagsModelTagsGetParams,) => {
    return [`/model/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getGetModelTagsModelTagsGetQueryOptions = <TData = Awaited<ReturnType<typeof getModelTagsModelTagsGet>>, TError = HTTPValidationError>(params?: GetModelTagsModelTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelTagsModelTagsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelTagsModelTagsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelTagsModelTagsGet>>> = ({ signal }) => getModelTagsModelTagsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelTagsModelTagsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelTagsModelTagsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getModelTagsModelTagsGet>>>
export type GetModelTagsModelTagsGetQueryError = HTTPValidationError


export function useGetModelTagsModelTagsGet<TData = Awaited<ReturnType<typeof getModelTagsModelTagsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetModelTagsModelTagsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelTagsModelTagsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelTagsModelTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getModelTagsModelTagsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelTagsModelTagsGet<TData = Awaited<ReturnType<typeof getModelTagsModelTagsGet>>, TError = HTTPValidationError>(
 params?: GetModelTagsModelTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelTagsModelTagsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelTagsModelTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getModelTagsModelTagsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelTagsModelTagsGet<TData = Awaited<ReturnType<typeof getModelTagsModelTagsGet>>, TError = HTTPValidationError>(
 params?: GetModelTagsModelTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelTagsModelTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Model Tags
 */

export function useGetModelTagsModelTagsGet<TData = Awaited<ReturnType<typeof getModelTagsModelTagsGet>>, TError = HTTPValidationError>(
 params?: GetModelTagsModelTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelTagsModelTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelTagsModelTagsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get dependency tree of descendants and parents of model.
 * @summary Get Model Tree
 */
export const getModelTreeModelTreeModelHashGet = (
    modelHash: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/model/tree/${modelHash}`, method: 'GET', signal
    },
      );
    }
  

export const getGetModelTreeModelTreeModelHashGetQueryKey = (modelHash: string,) => {
    return [`/model/tree/${modelHash}`] as const;
    }

    
export const getGetModelTreeModelTreeModelHashGetQueryOptions = <TData = Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>, TError = HTTPValidationError>(modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelTreeModelTreeModelHashGetQueryKey(modelHash);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>> = ({ signal }) => getModelTreeModelTreeModelHashGet(modelHash, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(modelHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelTreeModelTreeModelHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>>
export type GetModelTreeModelTreeModelHashGetQueryError = HTTPValidationError


export function useGetModelTreeModelTreeModelHashGet<TData = Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>, TError = HTTPValidationError>(
 modelHash: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>,
          TError,
          Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelTreeModelTreeModelHashGet<TData = Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>, TError = HTTPValidationError>(
 modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>,
          TError,
          Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelTreeModelTreeModelHashGet<TData = Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>, TError = HTTPValidationError>(
 modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Model Tree
 */

export function useGetModelTreeModelTreeModelHashGet<TData = Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>, TError = HTTPValidationError>(
 modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelTreeModelTreeModelHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelTreeModelTreeModelHashGetQueryOptions(modelHash,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to download a model
 * @summary Download Model
 */
export const downloadModelModelDownloadModelHashGet = (
    modelHash: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/model/download/${modelHash}`, method: 'GET', signal
    },
      );
    }
  

export const getDownloadModelModelDownloadModelHashGetQueryKey = (modelHash: string,) => {
    return [`/model/download/${modelHash}`] as const;
    }

    
export const getDownloadModelModelDownloadModelHashGetQueryOptions = <TData = Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>, TError = HTTPValidationError>(modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadModelModelDownloadModelHashGetQueryKey(modelHash);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>> = ({ signal }) => downloadModelModelDownloadModelHashGet(modelHash, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(modelHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadModelModelDownloadModelHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>>
export type DownloadModelModelDownloadModelHashGetQueryError = HTTPValidationError


export function useDownloadModelModelDownloadModelHashGet<TData = Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>, TError = HTTPValidationError>(
 modelHash: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>,
          TError,
          Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadModelModelDownloadModelHashGet<TData = Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>, TError = HTTPValidationError>(
 modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>,
          TError,
          Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadModelModelDownloadModelHashGet<TData = Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>, TError = HTTPValidationError>(
 modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download Model
 */

export function useDownloadModelModelDownloadModelHashGet<TData = Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>, TError = HTTPValidationError>(
 modelHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadModelModelDownloadModelHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadModelModelDownloadModelHashGetQueryOptions(modelHash,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * POST request to upload a model.

:param uploaded_file: binary of the file to upload. 
:param metadata: metadata for model
 * @summary Upload Model
 */
export const uploadModelModelUploadPost = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UploadModelResponse>(
      {url: `/model/upload`, method: 'POST', signal
    },
      );
    }
  


export const getUploadModelModelUploadPostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadModelModelUploadPost>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadModelModelUploadPost>>, TError,void, TContext> => {
    
const mutationKey = ['uploadModelModelUploadPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadModelModelUploadPost>>, void> = () => {
          

          return  uploadModelModelUploadPost()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadModelModelUploadPostMutationResult = NonNullable<Awaited<ReturnType<typeof uploadModelModelUploadPost>>>
    
    export type UploadModelModelUploadPostMutationError = unknown

    /**
 * @summary Upload Model
 */
export const useUploadModelModelUploadPost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadModelModelUploadPost>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof uploadModelModelUploadPost>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getUploadModelModelUploadPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * POST request to update a model.

:param model_hash: file_hash of the model to update. 
:param metadata: metadata for model
 * @summary Update Model
 */
export const updateModelModelUpdateModelHashPut = (
    modelHash: string,
    updateModelRequest: UpdateModelRequest,
 ) => {
      
      
      return customInstance<MessageResponse>(
      {url: `/model/update/${modelHash}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateModelRequest
    },
      );
    }
  


export const getUpdateModelModelUpdateModelHashPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelModelUpdateModelHashPut>>, TError,{modelHash: string;data: UpdateModelRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateModelModelUpdateModelHashPut>>, TError,{modelHash: string;data: UpdateModelRequest}, TContext> => {
    
const mutationKey = ['updateModelModelUpdateModelHashPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateModelModelUpdateModelHashPut>>, {modelHash: string;data: UpdateModelRequest}> = (props) => {
          const {modelHash,data} = props ?? {};

          return  updateModelModelUpdateModelHashPut(modelHash,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateModelModelUpdateModelHashPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateModelModelUpdateModelHashPut>>>
    export type UpdateModelModelUpdateModelHashPutMutationBody = UpdateModelRequest
    export type UpdateModelModelUpdateModelHashPutMutationError = HTTPValidationError

    /**
 * @summary Update Model
 */
export const useUpdateModelModelUpdateModelHashPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelModelUpdateModelHashPut>>, TError,{modelHash: string;data: UpdateModelRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof updateModelModelUpdateModelHashPut>>,
        TError,
        {modelHash: string;data: UpdateModelRequest},
        TContext
      > => {

      const mutationOptions = getUpdateModelModelUpdateModelHashPutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * API endpoint to get the supported model methods.
 * @summary Get Supported Model Methods
 */
export const getSupportedModelMethodsModelTrainSupportedModelMethodsGet = (
    params?: GetSupportedModelMethodsModelTrainSupportedModelMethodsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/model/train/supported_model_methods`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetSupportedModelMethodsModelTrainSupportedModelMethodsGetQueryKey = (params?: GetSupportedModelMethodsModelTrainSupportedModelMethodsGetParams,) => {
    return [`/model/train/supported_model_methods`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSupportedModelMethodsModelTrainSupportedModelMethodsGetQueryOptions = <TData = Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>, TError = HTTPValidationError>(params?: GetSupportedModelMethodsModelTrainSupportedModelMethodsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportedModelMethodsModelTrainSupportedModelMethodsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>> = ({ signal }) => getSupportedModelMethodsModelTrainSupportedModelMethodsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupportedModelMethodsModelTrainSupportedModelMethodsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>>
export type GetSupportedModelMethodsModelTrainSupportedModelMethodsGetQueryError = HTTPValidationError


export function useGetSupportedModelMethodsModelTrainSupportedModelMethodsGet<TData = Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetSupportedModelMethodsModelTrainSupportedModelMethodsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>,
          TError,
          Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedModelMethodsModelTrainSupportedModelMethodsGet<TData = Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>, TError = HTTPValidationError>(
 params?: GetSupportedModelMethodsModelTrainSupportedModelMethodsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>,
          TError,
          Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedModelMethodsModelTrainSupportedModelMethodsGet<TData = Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>, TError = HTTPValidationError>(
 params?: GetSupportedModelMethodsModelTrainSupportedModelMethodsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Supported Model Methods
 */

export function useGetSupportedModelMethodsModelTrainSupportedModelMethodsGet<TData = Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>, TError = HTTPValidationError>(
 params?: GetSupportedModelMethodsModelTrainSupportedModelMethodsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedModelMethodsModelTrainSupportedModelMethodsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSupportedModelMethodsModelTrainSupportedModelMethodsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * API endpoint to get supported unified source options for DCM training.
 * @summary Get Supported Dcm Sources
 */
export const getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/model/train/supported_dcm_sources`, method: 'GET', signal
    },
      );
    }
  

export const getGetSupportedDcmSourcesModelTrainSupportedDcmSourcesGetQueryKey = () => {
    return [`/model/train/supported_dcm_sources`] as const;
    }

    
export const getGetSupportedDcmSourcesModelTrainSupportedDcmSourcesGetQueryOptions = <TData = Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportedDcmSourcesModelTrainSupportedDcmSourcesGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>> = ({ signal }) => getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupportedDcmSourcesModelTrainSupportedDcmSourcesGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>>
export type GetSupportedDcmSourcesModelTrainSupportedDcmSourcesGetQueryError = unknown


export function useGetSupportedDcmSourcesModelTrainSupportedDcmSourcesGet<TData = Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>,
          TError,
          Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedDcmSourcesModelTrainSupportedDcmSourcesGet<TData = Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>,
          TError,
          Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedDcmSourcesModelTrainSupportedDcmSourcesGet<TData = Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Supported Dcm Sources
 */

export function useGetSupportedDcmSourcesModelTrainSupportedDcmSourcesGet<TData = Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedDcmSourcesModelTrainSupportedDcmSourcesGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSupportedDcmSourcesModelTrainSupportedDcmSourcesGetQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * API endpoint to get the suggested model methods to train on a given dataset.
This should suggest models methods based on dataset characteristics such as:
- number of data points
- distribution of activity values (in the future for regression)
- data imbalance (for classification)
 * @summary Get Suggested Model Methods
 */
export const getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet = (
    params?: GetSuggestedModelMethodsModelTrainSuggestedModelMethodsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/model/train/suggested_model_methods`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetSuggestedModelMethodsModelTrainSuggestedModelMethodsGetQueryKey = (params?: GetSuggestedModelMethodsModelTrainSuggestedModelMethodsGetParams,) => {
    return [`/model/train/suggested_model_methods`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSuggestedModelMethodsModelTrainSuggestedModelMethodsGetQueryOptions = <TData = Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>, TError = HTTPValidationError>(params?: GetSuggestedModelMethodsModelTrainSuggestedModelMethodsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSuggestedModelMethodsModelTrainSuggestedModelMethodsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>> = ({ signal }) => getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuggestedModelMethodsModelTrainSuggestedModelMethodsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>>
export type GetSuggestedModelMethodsModelTrainSuggestedModelMethodsGetQueryError = HTTPValidationError


export function useGetSuggestedModelMethodsModelTrainSuggestedModelMethodsGet<TData = Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetSuggestedModelMethodsModelTrainSuggestedModelMethodsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>,
          TError,
          Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuggestedModelMethodsModelTrainSuggestedModelMethodsGet<TData = Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>, TError = HTTPValidationError>(
 params?: GetSuggestedModelMethodsModelTrainSuggestedModelMethodsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>,
          TError,
          Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuggestedModelMethodsModelTrainSuggestedModelMethodsGet<TData = Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>, TError = HTTPValidationError>(
 params?: GetSuggestedModelMethodsModelTrainSuggestedModelMethodsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Suggested Model Methods
 */

export function useGetSuggestedModelMethodsModelTrainSuggestedModelMethodsGet<TData = Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>, TError = HTTPValidationError>(
 params?: GetSuggestedModelMethodsModelTrainSuggestedModelMethodsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuggestedModelMethodsModelTrainSuggestedModelMethodsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSuggestedModelMethodsModelTrainSuggestedModelMethodsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * API endpoint to validate the chosen model methods.
Returns a dictionary with warnings/errors if any of the chosen model methods are not supported or not suggested based on dataset characteristics.
 * @summary Validate Chosen Model Methods
 */
export const validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet = (
    params?: ValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGet200>(
      {url: `/model/train/validate_chosen_model_methods`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGetQueryKey = (params?: ValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGetParams,) => {
    return [`/model/train/validate_chosen_model_methods`, ...(params ? [params]: [])] as const;
    }

    
export const getValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGetQueryOptions = <TData = Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>, TError = HTTPValidationError>(params?: ValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>> = ({ signal }) => validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGetQueryResult = NonNullable<Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>>
export type ValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGetQueryError = HTTPValidationError


export function useValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGet<TData = Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>, TError = HTTPValidationError>(
 params: undefined |  ValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>,
          TError,
          Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGet<TData = Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>, TError = HTTPValidationError>(
 params?: ValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>,
          TError,
          Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGet<TData = Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>, TError = HTTPValidationError>(
 params?: ValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Validate Chosen Model Methods
 */

export function useValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGet<TData = Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>, TError = HTTPValidationError>(
 params?: ValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateChosenModelMethodsModelTrainValidateChosenModelMethodsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getValidateChosenModelMethodsModelTrainValidateChosenModelMethodsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * API endpoint to get the supported sampling methods.
 * @summary Get Supported Sampling Methods
 */
export const getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/model/train/supported_sampling_methods`, method: 'GET', signal
    },
      );
    }
  

export const getGetSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGetQueryKey = () => {
    return [`/model/train/supported_sampling_methods`] as const;
    }

    
export const getGetSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGetQueryOptions = <TData = Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>> = ({ signal }) => getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>>
export type GetSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGetQueryError = unknown


export function useGetSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet<TData = Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>,
          TError,
          Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet<TData = Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>,
          TError,
          Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet<TData = Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Supported Sampling Methods
 */

export function useGetSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet<TData = Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSupportedSamplingMethodsModelTrainSupportedSamplingMethodsGetQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Train Model
 */
export const trainModelModelTrainPost = (
    aCTrainModelDAGRequestModel: ACTrainModelDAGRequestModel,
    params?: TrainModelModelTrainPostParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/model/train`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aCTrainModelDAGRequestModel,
        params, signal
    },
      );
    }
  


export const getTrainModelModelTrainPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trainModelModelTrainPost>>, TError,{data: ACTrainModelDAGRequestModel;params?: TrainModelModelTrainPostParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof trainModelModelTrainPost>>, TError,{data: ACTrainModelDAGRequestModel;params?: TrainModelModelTrainPostParams}, TContext> => {
    
const mutationKey = ['trainModelModelTrainPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof trainModelModelTrainPost>>, {data: ACTrainModelDAGRequestModel;params?: TrainModelModelTrainPostParams}> = (props) => {
          const {data,params} = props ?? {};

          return  trainModelModelTrainPost(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TrainModelModelTrainPostMutationResult = NonNullable<Awaited<ReturnType<typeof trainModelModelTrainPost>>>
    export type TrainModelModelTrainPostMutationBody = ACTrainModelDAGRequestModel
    export type TrainModelModelTrainPostMutationError = HTTPValidationError

    /**
 * @summary Train Model
 */
export const useTrainModelModelTrainPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trainModelModelTrainPost>>, TError,{data: ACTrainModelDAGRequestModel;params?: TrainModelModelTrainPostParams}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof trainModelModelTrainPost>>,
        TError,
        {data: ACTrainModelDAGRequestModel;params?: TrainModelModelTrainPostParams},
        TContext
      > => {

      const mutationOptions = getTrainModelModelTrainPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * API endpoint to trigger MegaFingerprints DAG in Airflow. This will be used by service accounts to
fingerprint datasets in bulk for other pipelines. For example, for Domain Classification Modelling,
ChEMBL data is sampled multiple times and needs to be fingerprinted for each subsample.
 * @summary Fingerprint Data
 */
export const fingerprintDataModelFingerprintPost = (
    megaFingerprintsDAGRequestModel: MegaFingerprintsDAGRequestModel,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/model/fingerprint`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: megaFingerprintsDAGRequestModel, signal
    },
      );
    }
  


export const getFingerprintDataModelFingerprintPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fingerprintDataModelFingerprintPost>>, TError,{data: MegaFingerprintsDAGRequestModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof fingerprintDataModelFingerprintPost>>, TError,{data: MegaFingerprintsDAGRequestModel}, TContext> => {
    
const mutationKey = ['fingerprintDataModelFingerprintPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fingerprintDataModelFingerprintPost>>, {data: MegaFingerprintsDAGRequestModel}> = (props) => {
          const {data} = props ?? {};

          return  fingerprintDataModelFingerprintPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FingerprintDataModelFingerprintPostMutationResult = NonNullable<Awaited<ReturnType<typeof fingerprintDataModelFingerprintPost>>>
    export type FingerprintDataModelFingerprintPostMutationBody = MegaFingerprintsDAGRequestModel
    export type FingerprintDataModelFingerprintPostMutationError = HTTPValidationError

    /**
 * @summary Fingerprint Data
 */
export const useFingerprintDataModelFingerprintPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fingerprintDataModelFingerprintPost>>, TError,{data: MegaFingerprintsDAGRequestModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof fingerprintDataModelFingerprintPost>>,
        TError,
        {data: MegaFingerprintsDAGRequestModel},
        TContext
      > => {

      const mutationOptions = getFingerprintDataModelFingerprintPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * DELETE request to delete a model by its hash. This will also trigger cleanup of orphans in related tables such as model family and resultset.
 * @summary Delete Model
 */
export const deleteModelModelModelHashDelete = (
    modelHash: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/model/${modelHash}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteModelModelModelHashDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteModelModelModelHashDelete>>, TError,{modelHash: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteModelModelModelHashDelete>>, TError,{modelHash: string}, TContext> => {
    
const mutationKey = ['deleteModelModelModelHashDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteModelModelModelHashDelete>>, {modelHash: string}> = (props) => {
          const {modelHash} = props ?? {};

          return  deleteModelModelModelHashDelete(modelHash,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteModelModelModelHashDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteModelModelModelHashDelete>>>
    
    export type DeleteModelModelModelHashDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete Model
 */
export const useDeleteModelModelModelHashDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteModelModelModelHashDelete>>, TError,{modelHash: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteModelModelModelHashDelete>>,
        TError,
        {modelHash: string},
        TContext
      > => {

      const mutationOptions = getDeleteModelModelModelHashDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * GET request to get list of predictions (metadata ONLY)
 * @summary Get Predictions
 */
export const getPredictionsPredictionGet = (
    params?: GetPredictionsPredictionGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetPredictionsPredictionGet200>(
      {url: `/prediction/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetPredictionsPredictionGetQueryKey = (params?: GetPredictionsPredictionGetParams,) => {
    return [`/prediction/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPredictionsPredictionGetQueryOptions = <TData = Awaited<ReturnType<typeof getPredictionsPredictionGet>>, TError = HTTPValidationError>(params?: GetPredictionsPredictionGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionsPredictionGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPredictionsPredictionGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPredictionsPredictionGet>>> = ({ signal }) => getPredictionsPredictionGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPredictionsPredictionGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPredictionsPredictionGetQueryResult = NonNullable<Awaited<ReturnType<typeof getPredictionsPredictionGet>>>
export type GetPredictionsPredictionGetQueryError = HTTPValidationError


export function useGetPredictionsPredictionGet<TData = Awaited<ReturnType<typeof getPredictionsPredictionGet>>, TError = HTTPValidationError>(
 params: undefined |  GetPredictionsPredictionGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionsPredictionGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPredictionsPredictionGet>>,
          TError,
          Awaited<ReturnType<typeof getPredictionsPredictionGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPredictionsPredictionGet<TData = Awaited<ReturnType<typeof getPredictionsPredictionGet>>, TError = HTTPValidationError>(
 params?: GetPredictionsPredictionGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionsPredictionGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPredictionsPredictionGet>>,
          TError,
          Awaited<ReturnType<typeof getPredictionsPredictionGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPredictionsPredictionGet<TData = Awaited<ReturnType<typeof getPredictionsPredictionGet>>, TError = HTTPValidationError>(
 params?: GetPredictionsPredictionGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionsPredictionGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Predictions
 */

export function useGetPredictionsPredictionGet<TData = Awaited<ReturnType<typeof getPredictionsPredictionGet>>, TError = HTTPValidationError>(
 params?: GetPredictionsPredictionGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionsPredictionGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPredictionsPredictionGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the tags of prediction.
 * @summary Get Prediction Tags
 */
export const getPredictionTagsPredictionTagsGet = (
    params?: GetPredictionTagsPredictionTagsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/prediction/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetPredictionTagsPredictionTagsGetQueryKey = (params?: GetPredictionTagsPredictionTagsGetParams,) => {
    return [`/prediction/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPredictionTagsPredictionTagsGetQueryOptions = <TData = Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>, TError = HTTPValidationError>(params?: GetPredictionTagsPredictionTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPredictionTagsPredictionTagsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>> = ({ signal }) => getPredictionTagsPredictionTagsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPredictionTagsPredictionTagsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>>
export type GetPredictionTagsPredictionTagsGetQueryError = HTTPValidationError


export function useGetPredictionTagsPredictionTagsGet<TData = Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetPredictionTagsPredictionTagsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPredictionTagsPredictionTagsGet<TData = Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>, TError = HTTPValidationError>(
 params?: GetPredictionTagsPredictionTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPredictionTagsPredictionTagsGet<TData = Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>, TError = HTTPValidationError>(
 params?: GetPredictionTagsPredictionTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Prediction Tags
 */

export function useGetPredictionTagsPredictionTagsGet<TData = Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>, TError = HTTPValidationError>(
 params?: GetPredictionTagsPredictionTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionTagsPredictionTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPredictionTagsPredictionTagsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the tags of prediction.
 * @summary Get Single Prediction Tags
 */
export const getSinglePredictionTagsPredictionSinglePredictionTagsGet = (
    params?: GetSinglePredictionTagsPredictionSinglePredictionTagsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/prediction/single_prediction/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetSinglePredictionTagsPredictionSinglePredictionTagsGetQueryKey = (params?: GetSinglePredictionTagsPredictionSinglePredictionTagsGetParams,) => {
    return [`/prediction/single_prediction/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSinglePredictionTagsPredictionSinglePredictionTagsGetQueryOptions = <TData = Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>, TError = HTTPValidationError>(params?: GetSinglePredictionTagsPredictionSinglePredictionTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSinglePredictionTagsPredictionSinglePredictionTagsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>> = ({ signal }) => getSinglePredictionTagsPredictionSinglePredictionTagsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSinglePredictionTagsPredictionSinglePredictionTagsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>>
export type GetSinglePredictionTagsPredictionSinglePredictionTagsGetQueryError = HTTPValidationError


export function useGetSinglePredictionTagsPredictionSinglePredictionTagsGet<TData = Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetSinglePredictionTagsPredictionSinglePredictionTagsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSinglePredictionTagsPredictionSinglePredictionTagsGet<TData = Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>, TError = HTTPValidationError>(
 params?: GetSinglePredictionTagsPredictionSinglePredictionTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSinglePredictionTagsPredictionSinglePredictionTagsGet<TData = Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>, TError = HTTPValidationError>(
 params?: GetSinglePredictionTagsPredictionSinglePredictionTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Single Prediction Tags
 */

export function useGetSinglePredictionTagsPredictionSinglePredictionTagsGet<TData = Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>, TError = HTTPValidationError>(
 params?: GetSinglePredictionTagsPredictionSinglePredictionTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionTagsPredictionSinglePredictionTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSinglePredictionTagsPredictionSinglePredictionTagsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get dependency tree of descendants and parents of prediction.
 * @summary Get Prediction Tree
 */
export const getPredictionTreePredictionTreePredictionHashGet = (
    predictionHash: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/prediction/tree/${predictionHash}`, method: 'GET', signal
    },
      );
    }
  

export const getGetPredictionTreePredictionTreePredictionHashGetQueryKey = (predictionHash: string,) => {
    return [`/prediction/tree/${predictionHash}`] as const;
    }

    
export const getGetPredictionTreePredictionTreePredictionHashGetQueryOptions = <TData = Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>, TError = HTTPValidationError>(predictionHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPredictionTreePredictionTreePredictionHashGetQueryKey(predictionHash);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>> = ({ signal }) => getPredictionTreePredictionTreePredictionHashGet(predictionHash, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(predictionHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPredictionTreePredictionTreePredictionHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>>
export type GetPredictionTreePredictionTreePredictionHashGetQueryError = HTTPValidationError


export function useGetPredictionTreePredictionTreePredictionHashGet<TData = Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>, TError = HTTPValidationError>(
 predictionHash: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>,
          TError,
          Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPredictionTreePredictionTreePredictionHashGet<TData = Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>, TError = HTTPValidationError>(
 predictionHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>,
          TError,
          Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPredictionTreePredictionTreePredictionHashGet<TData = Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>, TError = HTTPValidationError>(
 predictionHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Prediction Tree
 */

export function useGetPredictionTreePredictionTreePredictionHashGet<TData = Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>, TError = HTTPValidationError>(
 predictionHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionTreePredictionTreePredictionHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPredictionTreePredictionTreePredictionHashGetQueryOptions(predictionHash,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the dataframe of the prediction with the
given prediction_hash

:param prediction_hash: the file_hash of the prediction
:param applicability_domain: Query parameter boolean to also join Applicability Domain results
 * @summary Get Prediction Dataframe
 */
export const getPredictionDataframePredictionDataframePredictionHashGet = (
    predictionHash: string,
    params?: GetPredictionDataframePredictionDataframePredictionHashGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/prediction/dataframe/${predictionHash}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetPredictionDataframePredictionDataframePredictionHashGetQueryKey = (predictionHash: string,
    params?: GetPredictionDataframePredictionDataframePredictionHashGetParams,) => {
    return [`/prediction/dataframe/${predictionHash}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPredictionDataframePredictionDataframePredictionHashGetQueryOptions = <TData = Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>, TError = HTTPValidationError>(predictionHash: string,
    params?: GetPredictionDataframePredictionDataframePredictionHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPredictionDataframePredictionDataframePredictionHashGetQueryKey(predictionHash,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>> = ({ signal }) => getPredictionDataframePredictionDataframePredictionHashGet(predictionHash,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(predictionHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPredictionDataframePredictionDataframePredictionHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>>
export type GetPredictionDataframePredictionDataframePredictionHashGetQueryError = HTTPValidationError


export function useGetPredictionDataframePredictionDataframePredictionHashGet<TData = Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>, TError = HTTPValidationError>(
 predictionHash: string,
    params: undefined |  GetPredictionDataframePredictionDataframePredictionHashGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>,
          TError,
          Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPredictionDataframePredictionDataframePredictionHashGet<TData = Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>, TError = HTTPValidationError>(
 predictionHash: string,
    params?: GetPredictionDataframePredictionDataframePredictionHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>,
          TError,
          Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPredictionDataframePredictionDataframePredictionHashGet<TData = Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>, TError = HTTPValidationError>(
 predictionHash: string,
    params?: GetPredictionDataframePredictionDataframePredictionHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Prediction Dataframe
 */

export function useGetPredictionDataframePredictionDataframePredictionHashGet<TData = Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>, TError = HTTPValidationError>(
 predictionHash: string,
    params?: GetPredictionDataframePredictionDataframePredictionHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionDataframePredictionDataframePredictionHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPredictionDataframePredictionDataframePredictionHashGetQueryOptions(predictionHash,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the molecule highlightings of the prediction with the
given prediction_hash

:param prediction_hash: the file_hash of the prediction
 * @summary Get Prediction Molecule Highlightings
 */
export const getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet = (
    predictionHash: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/prediction/molecule_highlightings/${predictionHash}`, method: 'GET', signal
    },
      );
    }
  

export const getGetPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGetQueryKey = (predictionHash: string,) => {
    return [`/prediction/molecule_highlightings/${predictionHash}`] as const;
    }

    
export const getGetPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGetQueryOptions = <TData = Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>, TError = HTTPValidationError>(predictionHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGetQueryKey(predictionHash);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>> = ({ signal }) => getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet(predictionHash, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(predictionHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>>
export type GetPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGetQueryError = HTTPValidationError


export function useGetPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet<TData = Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>, TError = HTTPValidationError>(
 predictionHash: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>,
          TError,
          Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet<TData = Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>, TError = HTTPValidationError>(
 predictionHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>,
          TError,
          Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet<TData = Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>, TError = HTTPValidationError>(
 predictionHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Prediction Molecule Highlightings
 */

export function useGetPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet<TData = Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>, TError = HTTPValidationError>(
 predictionHash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPredictionMoleculeHighlightingsPredictionMoleculeHighlightingsPredictionHashGetQueryOptions(predictionHash,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * POST request to upload a prediction.

:param uploaded_file: binary of the file to upload. 
:param metadata: metadata for prediction
 * @summary Upload Prediction
 */
export const uploadPredictionPredictionUploadPost = (
    bodyUploadPredictionPredictionUploadPost: BodyUploadPredictionPredictionUploadPost,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append('uploaded_file', bodyUploadPredictionPredictionUploadPost.uploaded_file)
formData.append('metadata', JSON.stringify(bodyUploadPredictionPredictionUploadPost.metadata));

      return customInstance<UploadPredictionResponse>(
      {url: `/prediction/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadPredictionPredictionUploadPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPredictionPredictionUploadPost>>, TError,{data: BodyUploadPredictionPredictionUploadPost}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadPredictionPredictionUploadPost>>, TError,{data: BodyUploadPredictionPredictionUploadPost}, TContext> => {
    
const mutationKey = ['uploadPredictionPredictionUploadPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadPredictionPredictionUploadPost>>, {data: BodyUploadPredictionPredictionUploadPost}> = (props) => {
          const {data} = props ?? {};

          return  uploadPredictionPredictionUploadPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadPredictionPredictionUploadPostMutationResult = NonNullable<Awaited<ReturnType<typeof uploadPredictionPredictionUploadPost>>>
    export type UploadPredictionPredictionUploadPostMutationBody = BodyUploadPredictionPredictionUploadPost
    export type UploadPredictionPredictionUploadPostMutationError = HTTPValidationError

    /**
 * @summary Upload Prediction
 */
export const useUploadPredictionPredictionUploadPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPredictionPredictionUploadPost>>, TError,{data: BodyUploadPredictionPredictionUploadPost}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof uploadPredictionPredictionUploadPost>>,
        TError,
        {data: BodyUploadPredictionPredictionUploadPost},
        TContext
      > => {

      const mutationOptions = getUploadPredictionPredictionUploadPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * POST request to update a prediction.

:param prediction_hash: file_hash of the prediction to update. 
:param metadata: metadata for prediction
 * @summary Update Prediction
 */
export const updatePredictionPredictionUpdatePredictionHashPut = (
    predictionHash: string,
    updatePredictionRequest: UpdatePredictionRequest,
 ) => {
      
      
      return customInstance<MessageResponse>(
      {url: `/prediction/update/${predictionHash}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePredictionRequest
    },
      );
    }
  


export const getUpdatePredictionPredictionUpdatePredictionHashPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePredictionPredictionUpdatePredictionHashPut>>, TError,{predictionHash: string;data: UpdatePredictionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePredictionPredictionUpdatePredictionHashPut>>, TError,{predictionHash: string;data: UpdatePredictionRequest}, TContext> => {
    
const mutationKey = ['updatePredictionPredictionUpdatePredictionHashPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePredictionPredictionUpdatePredictionHashPut>>, {predictionHash: string;data: UpdatePredictionRequest}> = (props) => {
          const {predictionHash,data} = props ?? {};

          return  updatePredictionPredictionUpdatePredictionHashPut(predictionHash,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePredictionPredictionUpdatePredictionHashPutMutationResult = NonNullable<Awaited<ReturnType<typeof updatePredictionPredictionUpdatePredictionHashPut>>>
    export type UpdatePredictionPredictionUpdatePredictionHashPutMutationBody = UpdatePredictionRequest
    export type UpdatePredictionPredictionUpdatePredictionHashPutMutationError = HTTPValidationError

    /**
 * @summary Update Prediction
 */
export const useUpdatePredictionPredictionUpdatePredictionHashPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePredictionPredictionUpdatePredictionHashPut>>, TError,{predictionHash: string;data: UpdatePredictionRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof updatePredictionPredictionUpdatePredictionHashPut>>,
        TError,
        {predictionHash: string;data: UpdatePredictionRequest},
        TContext
      > => {

      const mutationOptions = getUpdatePredictionPredictionUpdatePredictionHashPutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * DELETE request to delete a prediction with the given prediction_hash
 * @summary Delete Prediction
 */
export const deletePredictionPredictionPredictionHashDelete = (
    predictionHash: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/prediction/${predictionHash}`, method: 'DELETE'
    },
      );
    }
  


export const getDeletePredictionPredictionPredictionHashDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePredictionPredictionPredictionHashDelete>>, TError,{predictionHash: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePredictionPredictionPredictionHashDelete>>, TError,{predictionHash: string}, TContext> => {
    
const mutationKey = ['deletePredictionPredictionPredictionHashDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePredictionPredictionPredictionHashDelete>>, {predictionHash: string}> = (props) => {
          const {predictionHash} = props ?? {};

          return  deletePredictionPredictionPredictionHashDelete(predictionHash,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePredictionPredictionPredictionHashDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deletePredictionPredictionPredictionHashDelete>>>
    
    export type DeletePredictionPredictionPredictionHashDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete Prediction
 */
export const useDeletePredictionPredictionPredictionHashDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePredictionPredictionPredictionHashDelete>>, TError,{predictionHash: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deletePredictionPredictionPredictionHashDelete>>,
        TError,
        {predictionHash: string},
        TContext
      > => {

      const mutationOptions = getDeletePredictionPredictionPredictionHashDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * GET request to get list of jobs/dag_runs based on various parameters
 * @summary Get Jobs
 */
export const getJobsJobsGet = (
    params?: GetJobsJobsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/jobs/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetJobsJobsGetQueryKey = (params?: GetJobsJobsGetParams,) => {
    return [`/jobs/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetJobsJobsGetQueryOptions = <TData = Awaited<ReturnType<typeof getJobsJobsGet>>, TError = HTTPValidationError>(params?: GetJobsJobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsJobsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobsGet>>> = ({ signal }) => getJobsJobsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobsJobsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobsJobsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsJobsGet>>>
export type GetJobsJobsGetQueryError = HTTPValidationError


export function useGetJobsJobsGet<TData = Awaited<ReturnType<typeof getJobsJobsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetJobsJobsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobsGet>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobsGet<TData = Awaited<ReturnType<typeof getJobsJobsGet>>, TError = HTTPValidationError>(
 params?: GetJobsJobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobsGet>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobsGet<TData = Awaited<ReturnType<typeof getJobsJobsGet>>, TError = HTTPValidationError>(
 params?: GetJobsJobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Jobs
 */

export function useGetJobsJobsGet<TData = Awaited<ReturnType<typeof getJobsJobsGet>>, TError = HTTPValidationError>(
 params?: GetJobsJobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobsJobsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete Dag Run Endpoint
 */
export const deleteDagRunEndpointJobsDelete = (
    params: DeleteDagRunEndpointJobsDeleteParams,
 ) => {
      
      
      return customInstance<unknown>(
      {url: `/jobs/`, method: 'DELETE',
        params
    },
      );
    }
  


export const getDeleteDagRunEndpointJobsDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDagRunEndpointJobsDelete>>, TError,{params: DeleteDagRunEndpointJobsDeleteParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDagRunEndpointJobsDelete>>, TError,{params: DeleteDagRunEndpointJobsDeleteParams}, TContext> => {
    
const mutationKey = ['deleteDagRunEndpointJobsDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDagRunEndpointJobsDelete>>, {params: DeleteDagRunEndpointJobsDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteDagRunEndpointJobsDelete(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDagRunEndpointJobsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDagRunEndpointJobsDelete>>>
    
    export type DeleteDagRunEndpointJobsDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete Dag Run Endpoint
 */
export const useDeleteDagRunEndpointJobsDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDagRunEndpointJobsDelete>>, TError,{params: DeleteDagRunEndpointJobsDeleteParams}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteDagRunEndpointJobsDelete>>,
        TError,
        {params: DeleteDagRunEndpointJobsDeleteParams},
        TContext
      > => {

      const mutationOptions = getDeleteDagRunEndpointJobsDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * GET request to get tasks from Airflow.
 * @summary Get Task
 */
export const getTaskJobsTaskGet = (
    params: GetTaskJobsTaskGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/jobs/task`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetTaskJobsTaskGetQueryKey = (params: GetTaskJobsTaskGetParams,) => {
    return [`/jobs/task`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTaskJobsTaskGetQueryOptions = <TData = Awaited<ReturnType<typeof getTaskJobsTaskGet>>, TError = HTTPValidationError>(params: GetTaskJobsTaskGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskJobsTaskGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskJobsTaskGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskJobsTaskGet>>> = ({ signal }) => getTaskJobsTaskGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskJobsTaskGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskJobsTaskGetQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskJobsTaskGet>>>
export type GetTaskJobsTaskGetQueryError = HTTPValidationError


export function useGetTaskJobsTaskGet<TData = Awaited<ReturnType<typeof getTaskJobsTaskGet>>, TError = HTTPValidationError>(
 params: GetTaskJobsTaskGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskJobsTaskGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskJobsTaskGet>>,
          TError,
          Awaited<ReturnType<typeof getTaskJobsTaskGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskJobsTaskGet<TData = Awaited<ReturnType<typeof getTaskJobsTaskGet>>, TError = HTTPValidationError>(
 params: GetTaskJobsTaskGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskJobsTaskGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskJobsTaskGet>>,
          TError,
          Awaited<ReturnType<typeof getTaskJobsTaskGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskJobsTaskGet<TData = Awaited<ReturnType<typeof getTaskJobsTaskGet>>, TError = HTTPValidationError>(
 params: GetTaskJobsTaskGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskJobsTaskGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Task
 */

export function useGetTaskJobsTaskGet<TData = Awaited<ReturnType<typeof getTaskJobsTaskGet>>, TError = HTTPValidationError>(
 params: GetTaskJobsTaskGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskJobsTaskGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskJobsTaskGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Cancel Dag Run Endpoint
 */
export const cancelDagRunEndpointJobsCancelPost = (
    params: CancelDagRunEndpointJobsCancelPostParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/jobs/cancel`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getCancelDagRunEndpointJobsCancelPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelDagRunEndpointJobsCancelPost>>, TError,{params: CancelDagRunEndpointJobsCancelPostParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelDagRunEndpointJobsCancelPost>>, TError,{params: CancelDagRunEndpointJobsCancelPostParams}, TContext> => {
    
const mutationKey = ['cancelDagRunEndpointJobsCancelPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelDagRunEndpointJobsCancelPost>>, {params: CancelDagRunEndpointJobsCancelPostParams}> = (props) => {
          const {params} = props ?? {};

          return  cancelDagRunEndpointJobsCancelPost(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelDagRunEndpointJobsCancelPostMutationResult = NonNullable<Awaited<ReturnType<typeof cancelDagRunEndpointJobsCancelPost>>>
    
    export type CancelDagRunEndpointJobsCancelPostMutationError = HTTPValidationError

    /**
 * @summary Cancel Dag Run Endpoint
 */
export const useCancelDagRunEndpointJobsCancelPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelDagRunEndpointJobsCancelPost>>, TError,{params: CancelDagRunEndpointJobsCancelPostParams}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cancelDagRunEndpointJobsCancelPost>>,
        TError,
        {params: CancelDagRunEndpointJobsCancelPostParams},
        TContext
      > => {

      const mutationOptions = getCancelDagRunEndpointJobsCancelPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Clear Task Endpoint
 */
export const clearTaskEndpointJobsClearTaskPost = (
    clearTaskRequest: ClearTaskRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ClearTaskResponse>(
      {url: `/jobs/clear_task`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: clearTaskRequest, signal
    },
      );
    }
  


export const getClearTaskEndpointJobsClearTaskPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearTaskEndpointJobsClearTaskPost>>, TError,{data: ClearTaskRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clearTaskEndpointJobsClearTaskPost>>, TError,{data: ClearTaskRequest}, TContext> => {
    
const mutationKey = ['clearTaskEndpointJobsClearTaskPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearTaskEndpointJobsClearTaskPost>>, {data: ClearTaskRequest}> = (props) => {
          const {data} = props ?? {};

          return  clearTaskEndpointJobsClearTaskPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClearTaskEndpointJobsClearTaskPostMutationResult = NonNullable<Awaited<ReturnType<typeof clearTaskEndpointJobsClearTaskPost>>>
    export type ClearTaskEndpointJobsClearTaskPostMutationBody = ClearTaskRequest
    export type ClearTaskEndpointJobsClearTaskPostMutationError = HTTPValidationError

    /**
 * @summary Clear Task Endpoint
 */
export const useClearTaskEndpointJobsClearTaskPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearTaskEndpointJobsClearTaskPost>>, TError,{data: ClearTaskRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof clearTaskEndpointJobsClearTaskPost>>,
        TError,
        {data: ClearTaskRequest},
        TContext
      > => {

      const mutationOptions = getClearTaskEndpointJobsClearTaskPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Clear Dag Run Endpoint
 */
export const clearDagRunEndpointJobsClearDagRunPost = (
    clearDAGRunRequest: ClearDAGRunRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ClearDAGRunResponse>(
      {url: `/jobs/clear_dag_run`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: clearDAGRunRequest, signal
    },
      );
    }
  


export const getClearDagRunEndpointJobsClearDagRunPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearDagRunEndpointJobsClearDagRunPost>>, TError,{data: ClearDAGRunRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clearDagRunEndpointJobsClearDagRunPost>>, TError,{data: ClearDAGRunRequest}, TContext> => {
    
const mutationKey = ['clearDagRunEndpointJobsClearDagRunPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearDagRunEndpointJobsClearDagRunPost>>, {data: ClearDAGRunRequest}> = (props) => {
          const {data} = props ?? {};

          return  clearDagRunEndpointJobsClearDagRunPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClearDagRunEndpointJobsClearDagRunPostMutationResult = NonNullable<Awaited<ReturnType<typeof clearDagRunEndpointJobsClearDagRunPost>>>
    export type ClearDagRunEndpointJobsClearDagRunPostMutationBody = ClearDAGRunRequest
    export type ClearDagRunEndpointJobsClearDagRunPostMutationError = HTTPValidationError

    /**
 * @summary Clear Dag Run Endpoint
 */
export const useClearDagRunEndpointJobsClearDagRunPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearDagRunEndpointJobsClearDagRunPost>>, TError,{data: ClearDAGRunRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof clearDagRunEndpointJobsClearDagRunPost>>,
        TError,
        {data: ClearDAGRunRequest},
        TContext
      > => {

      const mutationOptions = getClearDagRunEndpointJobsClearDagRunPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Redirects user to keycloak console
 * @summary Keycloak Redirect
 */
export const keycloakRedirectKeycloakConsoleGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/keycloak/console`, method: 'GET', signal
    },
      );
    }
  

export const getKeycloakRedirectKeycloakConsoleGetQueryKey = () => {
    return [`/keycloak/console`] as const;
    }

    
export const getKeycloakRedirectKeycloakConsoleGetQueryOptions = <TData = Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKeycloakRedirectKeycloakConsoleGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>> = ({ signal }) => keycloakRedirectKeycloakConsoleGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KeycloakRedirectKeycloakConsoleGetQueryResult = NonNullable<Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>>
export type KeycloakRedirectKeycloakConsoleGetQueryError = unknown


export function useKeycloakRedirectKeycloakConsoleGet<TData = Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>,
          TError,
          Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKeycloakRedirectKeycloakConsoleGet<TData = Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>,
          TError,
          Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKeycloakRedirectKeycloakConsoleGet<TData = Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Keycloak Redirect
 */

export function useKeycloakRedirectKeycloakConsoleGet<TData = Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keycloakRedirectKeycloakConsoleGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKeycloakRedirectKeycloakConsoleGetQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get list of model_families (metadata ONLY)
 * @summary Get Model Families
 */
export const getModelFamiliesModelFamilyGet = (
    params?: GetModelFamiliesModelFamilyGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetModelFamiliesModelFamilyGet200>(
      {url: `/model_family/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetModelFamiliesModelFamilyGetQueryKey = (params?: GetModelFamiliesModelFamilyGetParams,) => {
    return [`/model_family/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetModelFamiliesModelFamilyGetQueryOptions = <TData = Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>, TError = HTTPValidationError>(params?: GetModelFamiliesModelFamilyGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelFamiliesModelFamilyGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>> = ({ signal }) => getModelFamiliesModelFamilyGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelFamiliesModelFamilyGetQueryResult = NonNullable<Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>>
export type GetModelFamiliesModelFamilyGetQueryError = HTTPValidationError


export function useGetModelFamiliesModelFamilyGet<TData = Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>, TError = HTTPValidationError>(
 params: undefined |  GetModelFamiliesModelFamilyGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamiliesModelFamilyGet<TData = Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>, TError = HTTPValidationError>(
 params?: GetModelFamiliesModelFamilyGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamiliesModelFamilyGet<TData = Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>, TError = HTTPValidationError>(
 params?: GetModelFamiliesModelFamilyGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Model Families
 */

export function useGetModelFamiliesModelFamilyGet<TData = Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>, TError = HTTPValidationError>(
 params?: GetModelFamiliesModelFamilyGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesModelFamilyGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelFamiliesModelFamilyGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * POST request to create a model_family.

:param metadata: metadata for model_family
 * @summary Create Model Family
 */
export const createModelFamilyModelFamilyPost = (
    createModelFamilyRequest: CreateModelFamilyRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateModelFamilyResponse>(
      {url: `/model_family/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createModelFamilyRequest, signal
    },
      );
    }
  


export const getCreateModelFamilyModelFamilyPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelFamilyModelFamilyPost>>, TError,{data: CreateModelFamilyRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createModelFamilyModelFamilyPost>>, TError,{data: CreateModelFamilyRequest}, TContext> => {
    
const mutationKey = ['createModelFamilyModelFamilyPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createModelFamilyModelFamilyPost>>, {data: CreateModelFamilyRequest}> = (props) => {
          const {data} = props ?? {};

          return  createModelFamilyModelFamilyPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateModelFamilyModelFamilyPostMutationResult = NonNullable<Awaited<ReturnType<typeof createModelFamilyModelFamilyPost>>>
    export type CreateModelFamilyModelFamilyPostMutationBody = CreateModelFamilyRequest
    export type CreateModelFamilyModelFamilyPostMutationError = HTTPValidationError

    /**
 * @summary Create Model Family
 */
export const useCreateModelFamilyModelFamilyPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelFamilyModelFamilyPost>>, TError,{data: CreateModelFamilyRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof createModelFamilyModelFamilyPost>>,
        TError,
        {data: CreateModelFamilyRequest},
        TContext
      > => {

      const mutationOptions = getCreateModelFamilyModelFamilyPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * GET all versions of a model family group identified by (owner, name).
Returns all model families matching the owner+name combination, sorted by creation_date desc by default.
 * @summary Get Model Family Versions
 */
export const getModelFamilyVersionsModelFamilyVersionsGet = (
    params: GetModelFamilyVersionsModelFamilyVersionsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ModelFamilyListResponse>(
      {url: `/model_family/versions`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetModelFamilyVersionsModelFamilyVersionsGetQueryKey = (params: GetModelFamilyVersionsModelFamilyVersionsGetParams,) => {
    return [`/model_family/versions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetModelFamilyVersionsModelFamilyVersionsGetQueryOptions = <TData = Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>, TError = HTTPValidationError>(params: GetModelFamilyVersionsModelFamilyVersionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelFamilyVersionsModelFamilyVersionsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>> = ({ signal }) => getModelFamilyVersionsModelFamilyVersionsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelFamilyVersionsModelFamilyVersionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>>
export type GetModelFamilyVersionsModelFamilyVersionsGetQueryError = HTTPValidationError


export function useGetModelFamilyVersionsModelFamilyVersionsGet<TData = Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>, TError = HTTPValidationError>(
 params: GetModelFamilyVersionsModelFamilyVersionsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamilyVersionsModelFamilyVersionsGet<TData = Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>, TError = HTTPValidationError>(
 params: GetModelFamilyVersionsModelFamilyVersionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamilyVersionsModelFamilyVersionsGet<TData = Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>, TError = HTTPValidationError>(
 params: GetModelFamilyVersionsModelFamilyVersionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Model Family Versions
 */

export function useGetModelFamilyVersionsModelFamilyVersionsGet<TData = Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>, TError = HTTPValidationError>(
 params: GetModelFamilyVersionsModelFamilyVersionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyVersionsModelFamilyVersionsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelFamilyVersionsModelFamilyVersionsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get list of model_families (metadata ONLY)
 * @deprecated
 * @summary Get Model Families Count
 */
export const getModelFamiliesCountModelFamilyCountGet = (
    params?: GetModelFamiliesCountModelFamilyCountGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/model_family/count`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetModelFamiliesCountModelFamilyCountGetQueryKey = (params?: GetModelFamiliesCountModelFamilyCountGetParams,) => {
    return [`/model_family/count`, ...(params ? [params]: [])] as const;
    }

    
export const getGetModelFamiliesCountModelFamilyCountGetQueryOptions = <TData = Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>, TError = HTTPValidationError>(params?: GetModelFamiliesCountModelFamilyCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelFamiliesCountModelFamilyCountGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>> = ({ signal }) => getModelFamiliesCountModelFamilyCountGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelFamiliesCountModelFamilyCountGetQueryResult = NonNullable<Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>>
export type GetModelFamiliesCountModelFamilyCountGetQueryError = HTTPValidationError


export function useGetModelFamiliesCountModelFamilyCountGet<TData = Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>, TError = HTTPValidationError>(
 params: undefined |  GetModelFamiliesCountModelFamilyCountGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamiliesCountModelFamilyCountGet<TData = Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>, TError = HTTPValidationError>(
 params?: GetModelFamiliesCountModelFamilyCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamiliesCountModelFamilyCountGet<TData = Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>, TError = HTTPValidationError>(
 params?: GetModelFamiliesCountModelFamilyCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Get Model Families Count
 */

export function useGetModelFamiliesCountModelFamilyCountGet<TData = Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>, TError = HTTPValidationError>(
 params?: GetModelFamiliesCountModelFamilyCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesCountModelFamilyCountGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelFamiliesCountModelFamilyCountGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the tags of Model Family.
 * @summary Get Model Family Tags
 */
export const getModelFamilyTagsModelFamilyTagsGet = (
    params?: GetModelFamilyTagsModelFamilyTagsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/model_family/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetModelFamilyTagsModelFamilyTagsGetQueryKey = (params?: GetModelFamilyTagsModelFamilyTagsGetParams,) => {
    return [`/model_family/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getGetModelFamilyTagsModelFamilyTagsGetQueryOptions = <TData = Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>, TError = HTTPValidationError>(params?: GetModelFamilyTagsModelFamilyTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelFamilyTagsModelFamilyTagsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>> = ({ signal }) => getModelFamilyTagsModelFamilyTagsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelFamilyTagsModelFamilyTagsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>>
export type GetModelFamilyTagsModelFamilyTagsGetQueryError = HTTPValidationError


export function useGetModelFamilyTagsModelFamilyTagsGet<TData = Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetModelFamilyTagsModelFamilyTagsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamilyTagsModelFamilyTagsGet<TData = Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>, TError = HTTPValidationError>(
 params?: GetModelFamilyTagsModelFamilyTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamilyTagsModelFamilyTagsGet<TData = Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>, TError = HTTPValidationError>(
 params?: GetModelFamilyTagsModelFamilyTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Model Family Tags
 */

export function useGetModelFamilyTagsModelFamilyTagsGet<TData = Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>, TError = HTTPValidationError>(
 params?: GetModelFamilyTagsModelFamilyTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTagsModelFamilyTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelFamilyTagsModelFamilyTagsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the tag hierarchy counts of Model Family.
 * @summary Get Model Family Tag Hierarchy Counts
 */
export const getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet = (
    params?: GetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/model_family/tags/hierarchy_counts`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGetQueryKey = (params?: GetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGetParams,) => {
    return [`/model_family/tags/hierarchy_counts`, ...(params ? [params]: [])] as const;
    }

    
export const getGetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGetQueryOptions = <TData = Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>, TError = HTTPValidationError>(params?: GetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>> = ({ signal }) => getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>>
export type GetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGetQueryError = HTTPValidationError


export function useGetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet<TData = Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet<TData = Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>, TError = HTTPValidationError>(
 params?: GetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet<TData = Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>, TError = HTTPValidationError>(
 params?: GetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Model Family Tag Hierarchy Counts
 */

export function useGetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet<TData = Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>, TError = HTTPValidationError>(
 params?: GetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelFamilyTagHierarchyCountsModelFamilyTagsHierarchyCountsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get dependency tree of descendants and parents of model_family.
 * @summary Get Model Family Tree
 */
export const getModelFamilyTreeModelFamilyTreeModelFamilyIdGet = (
    modelFamilyId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/model_family/tree/${modelFamilyId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetModelFamilyTreeModelFamilyTreeModelFamilyIdGetQueryKey = (modelFamilyId: number,) => {
    return [`/model_family/tree/${modelFamilyId}`] as const;
    }

    
export const getGetModelFamilyTreeModelFamilyTreeModelFamilyIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>, TError = HTTPValidationError>(modelFamilyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelFamilyTreeModelFamilyTreeModelFamilyIdGetQueryKey(modelFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>> = ({ signal }) => getModelFamilyTreeModelFamilyTreeModelFamilyIdGet(modelFamilyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(modelFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelFamilyTreeModelFamilyTreeModelFamilyIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>>
export type GetModelFamilyTreeModelFamilyTreeModelFamilyIdGetQueryError = HTTPValidationError


export function useGetModelFamilyTreeModelFamilyTreeModelFamilyIdGet<TData = Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>, TError = HTTPValidationError>(
 modelFamilyId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamilyTreeModelFamilyTreeModelFamilyIdGet<TData = Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>, TError = HTTPValidationError>(
 modelFamilyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamilyTreeModelFamilyTreeModelFamilyIdGet<TData = Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>, TError = HTTPValidationError>(
 modelFamilyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Model Family Tree
 */

export function useGetModelFamilyTreeModelFamilyTreeModelFamilyIdGet<TData = Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>, TError = HTTPValidationError>(
 modelFamilyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyTreeModelFamilyTreeModelFamilyIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelFamilyTreeModelFamilyTreeModelFamilyIdGetQueryOptions(modelFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get models metadata for a specific model_family

:param model_family_id: the id of the model_family
 * @summary Get Model Family Models Metadata
 */
export const getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet = (
    modelFamilyId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Model[]>(
      {url: `/model_family/models/${modelFamilyId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGetQueryKey = (modelFamilyId: number,) => {
    return [`/model_family/models/${modelFamilyId}`] as const;
    }

    
export const getGetModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>, TError = HTTPValidationError>(modelFamilyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGetQueryKey(modelFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>> = ({ signal }) => getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet(modelFamilyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(modelFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>>
export type GetModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGetQueryError = HTTPValidationError


export function useGetModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet<TData = Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>, TError = HTTPValidationError>(
 modelFamilyId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet<TData = Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>, TError = HTTPValidationError>(
 modelFamilyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet<TData = Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>, TError = HTTPValidationError>(
 modelFamilyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Model Family Models Metadata
 */

export function useGetModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet<TData = Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>, TError = HTTPValidationError>(
 modelFamilyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelFamilyModelsMetadataModelFamilyModelsModelFamilyIdGetQueryOptions(modelFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * POST request to add a model to a model_family

:param add_model_metadata: either a single model_hash or list of model_hash's to add 
                            and model_family_id
 * @summary Add Model
 */
export const addModelModelFamilyAddModelPost = (
    addModelToModelFamilyRequest: AddModelToModelFamilyRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MessageResponse>(
      {url: `/model_family/add_model`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addModelToModelFamilyRequest, signal
    },
      );
    }
  


export const getAddModelModelFamilyAddModelPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addModelModelFamilyAddModelPost>>, TError,{data: AddModelToModelFamilyRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addModelModelFamilyAddModelPost>>, TError,{data: AddModelToModelFamilyRequest}, TContext> => {
    
const mutationKey = ['addModelModelFamilyAddModelPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addModelModelFamilyAddModelPost>>, {data: AddModelToModelFamilyRequest}> = (props) => {
          const {data} = props ?? {};

          return  addModelModelFamilyAddModelPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddModelModelFamilyAddModelPostMutationResult = NonNullable<Awaited<ReturnType<typeof addModelModelFamilyAddModelPost>>>
    export type AddModelModelFamilyAddModelPostMutationBody = AddModelToModelFamilyRequest
    export type AddModelModelFamilyAddModelPostMutationError = HTTPValidationError

    /**
 * @summary Add Model
 */
export const useAddModelModelFamilyAddModelPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addModelModelFamilyAddModelPost>>, TError,{data: AddModelToModelFamilyRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof addModelModelFamilyAddModelPost>>,
        TError,
        {data: AddModelToModelFamilyRequest},
        TContext
      > => {

      const mutationOptions = getAddModelModelFamilyAddModelPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * DELETE request for model families
 * @summary Delete Model Family
 */
export const deleteModelFamilyModelFamilyModelFamilyIdDelete = (
    modelFamilyId: number,
    params?: DeleteModelFamilyModelFamilyModelFamilyIdDeleteParams,
 ) => {
      
      
      return customInstance<void>(
      {url: `/model_family/${modelFamilyId}`, method: 'DELETE',
        params
    },
      );
    }
  


export const getDeleteModelFamilyModelFamilyModelFamilyIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteModelFamilyModelFamilyModelFamilyIdDelete>>, TError,{modelFamilyId: number;params?: DeleteModelFamilyModelFamilyModelFamilyIdDeleteParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteModelFamilyModelFamilyModelFamilyIdDelete>>, TError,{modelFamilyId: number;params?: DeleteModelFamilyModelFamilyModelFamilyIdDeleteParams}, TContext> => {
    
const mutationKey = ['deleteModelFamilyModelFamilyModelFamilyIdDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteModelFamilyModelFamilyModelFamilyIdDelete>>, {modelFamilyId: number;params?: DeleteModelFamilyModelFamilyModelFamilyIdDeleteParams}> = (props) => {
          const {modelFamilyId,params} = props ?? {};

          return  deleteModelFamilyModelFamilyModelFamilyIdDelete(modelFamilyId,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteModelFamilyModelFamilyModelFamilyIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteModelFamilyModelFamilyModelFamilyIdDelete>>>
    
    export type DeleteModelFamilyModelFamilyModelFamilyIdDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete Model Family
 */
export const useDeleteModelFamilyModelFamilyModelFamilyIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteModelFamilyModelFamilyModelFamilyIdDelete>>, TError,{modelFamilyId: number;params?: DeleteModelFamilyModelFamilyModelFamilyIdDeleteParams}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteModelFamilyModelFamilyModelFamilyIdDelete>>,
        TError,
        {modelFamilyId: number;params?: DeleteModelFamilyModelFamilyModelFamilyIdDeleteParams},
        TContext
      > => {

      const mutationOptions = getDeleteModelFamilyModelFamilyModelFamilyIdDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Check for duplicate model families
 * @summary Check Duplicate Model Family
 */
export const checkDuplicateModelFamilyModelFamilyGetDuplicatesGet = (
    params: CheckDuplicateModelFamilyModelFamilyGetDuplicatesGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ModelFamily[]>(
      {url: `/model_family/get_duplicates`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCheckDuplicateModelFamilyModelFamilyGetDuplicatesGetQueryKey = (params: CheckDuplicateModelFamilyModelFamilyGetDuplicatesGetParams,) => {
    return [`/model_family/get_duplicates`, ...(params ? [params]: [])] as const;
    }

    
export const getCheckDuplicateModelFamilyModelFamilyGetDuplicatesGetQueryOptions = <TData = Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>, TError = HTTPValidationError>(params: CheckDuplicateModelFamilyModelFamilyGetDuplicatesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckDuplicateModelFamilyModelFamilyGetDuplicatesGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>> = ({ signal }) => checkDuplicateModelFamilyModelFamilyGetDuplicatesGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CheckDuplicateModelFamilyModelFamilyGetDuplicatesGetQueryResult = NonNullable<Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>>
export type CheckDuplicateModelFamilyModelFamilyGetDuplicatesGetQueryError = HTTPValidationError


export function useCheckDuplicateModelFamilyModelFamilyGetDuplicatesGet<TData = Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>, TError = HTTPValidationError>(
 params: CheckDuplicateModelFamilyModelFamilyGetDuplicatesGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>,
          TError,
          Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckDuplicateModelFamilyModelFamilyGetDuplicatesGet<TData = Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>, TError = HTTPValidationError>(
 params: CheckDuplicateModelFamilyModelFamilyGetDuplicatesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>,
          TError,
          Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckDuplicateModelFamilyModelFamilyGetDuplicatesGet<TData = Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>, TError = HTTPValidationError>(
 params: CheckDuplicateModelFamilyModelFamilyGetDuplicatesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check Duplicate Model Family
 */

export function useCheckDuplicateModelFamilyModelFamilyGetDuplicatesGet<TData = Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>, TError = HTTPValidationError>(
 params: CheckDuplicateModelFamilyModelFamilyGetDuplicatesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkDuplicateModelFamilyModelFamilyGetDuplicatesGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCheckDuplicateModelFamilyModelFamilyGetDuplicatesGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get Resultsets
 */
export const getResultsetsResultsetGet = (
    params?: GetResultsetsResultsetGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetResultsetsResultsetGet200>(
      {url: `/resultset/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetResultsetsResultsetGetQueryKey = (params?: GetResultsetsResultsetGetParams,) => {
    return [`/resultset/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetResultsetsResultsetGetQueryOptions = <TData = Awaited<ReturnType<typeof getResultsetsResultsetGet>>, TError = HTTPValidationError>(params?: GetResultsetsResultsetGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetsResultsetGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResultsetsResultsetGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResultsetsResultsetGet>>> = ({ signal }) => getResultsetsResultsetGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResultsetsResultsetGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResultsetsResultsetGetQueryResult = NonNullable<Awaited<ReturnType<typeof getResultsetsResultsetGet>>>
export type GetResultsetsResultsetGetQueryError = HTTPValidationError


export function useGetResultsetsResultsetGet<TData = Awaited<ReturnType<typeof getResultsetsResultsetGet>>, TError = HTTPValidationError>(
 params: undefined |  GetResultsetsResultsetGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetsResultsetGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetsResultsetGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetsResultsetGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetsResultsetGet<TData = Awaited<ReturnType<typeof getResultsetsResultsetGet>>, TError = HTTPValidationError>(
 params?: GetResultsetsResultsetGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetsResultsetGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetsResultsetGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetsResultsetGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetsResultsetGet<TData = Awaited<ReturnType<typeof getResultsetsResultsetGet>>, TError = HTTPValidationError>(
 params?: GetResultsetsResultsetGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetsResultsetGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Resultsets
 */

export function useGetResultsetsResultsetGet<TData = Awaited<ReturnType<typeof getResultsetsResultsetGet>>, TError = HTTPValidationError>(
 params?: GetResultsetsResultsetGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetsResultsetGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResultsetsResultsetGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * POST request to create a resultset.

:param metadata: metadata for resultset
 * @summary Create Resultset
 */
export const createResultsetResultsetPost = (
    createResultsetRequest: CreateResultsetRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateResultsetResponse>(
      {url: `/resultset/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createResultsetRequest, signal
    },
      );
    }
  


export const getCreateResultsetResultsetPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResultsetResultsetPost>>, TError,{data: CreateResultsetRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createResultsetResultsetPost>>, TError,{data: CreateResultsetRequest}, TContext> => {
    
const mutationKey = ['createResultsetResultsetPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createResultsetResultsetPost>>, {data: CreateResultsetRequest}> = (props) => {
          const {data} = props ?? {};

          return  createResultsetResultsetPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateResultsetResultsetPostMutationResult = NonNullable<Awaited<ReturnType<typeof createResultsetResultsetPost>>>
    export type CreateResultsetResultsetPostMutationBody = CreateResultsetRequest
    export type CreateResultsetResultsetPostMutationError = HTTPValidationError

    /**
 * @summary Create Resultset
 */
export const useCreateResultsetResultsetPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResultsetResultsetPost>>, TError,{data: CreateResultsetRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof createResultsetResultsetPost>>,
        TError,
        {data: CreateResultsetRequest},
        TContext
      > => {

      const mutationOptions = getCreateResultsetResultsetPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get Resultsets Count
 */
export const getResultsetsCountResultsetCountGet = (
    params?: GetResultsetsCountResultsetCountGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/resultset/count`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetResultsetsCountResultsetCountGetQueryKey = (params?: GetResultsetsCountResultsetCountGetParams,) => {
    return [`/resultset/count`, ...(params ? [params]: [])] as const;
    }

    
export const getGetResultsetsCountResultsetCountGetQueryOptions = <TData = Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>, TError = HTTPValidationError>(params?: GetResultsetsCountResultsetCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResultsetsCountResultsetCountGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>> = ({ signal }) => getResultsetsCountResultsetCountGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResultsetsCountResultsetCountGetQueryResult = NonNullable<Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>>
export type GetResultsetsCountResultsetCountGetQueryError = HTTPValidationError


export function useGetResultsetsCountResultsetCountGet<TData = Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>, TError = HTTPValidationError>(
 params: undefined |  GetResultsetsCountResultsetCountGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetsCountResultsetCountGet<TData = Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>, TError = HTTPValidationError>(
 params?: GetResultsetsCountResultsetCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetsCountResultsetCountGet<TData = Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>, TError = HTTPValidationError>(
 params?: GetResultsetsCountResultsetCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Resultsets Count
 */

export function useGetResultsetsCountResultsetCountGet<TData = Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>, TError = HTTPValidationError>(
 params?: GetResultsetsCountResultsetCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetsCountResultsetCountGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResultsetsCountResultsetCountGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get Single Prediction Resultsets
 */
export const getSinglePredictionResultsetsResultsetSinglePredictionGet = (
    params?: GetSinglePredictionResultsetsResultsetSinglePredictionGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetSinglePredictionResultsetsResultsetSinglePredictionGet200>(
      {url: `/resultset/single_prediction`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetSinglePredictionResultsetsResultsetSinglePredictionGetQueryKey = (params?: GetSinglePredictionResultsetsResultsetSinglePredictionGetParams,) => {
    return [`/resultset/single_prediction`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSinglePredictionResultsetsResultsetSinglePredictionGetQueryOptions = <TData = Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>, TError = HTTPValidationError>(params?: GetSinglePredictionResultsetsResultsetSinglePredictionGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSinglePredictionResultsetsResultsetSinglePredictionGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>> = ({ signal }) => getSinglePredictionResultsetsResultsetSinglePredictionGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSinglePredictionResultsetsResultsetSinglePredictionGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>>
export type GetSinglePredictionResultsetsResultsetSinglePredictionGetQueryError = HTTPValidationError


export function useGetSinglePredictionResultsetsResultsetSinglePredictionGet<TData = Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>, TError = HTTPValidationError>(
 params: undefined |  GetSinglePredictionResultsetsResultsetSinglePredictionGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>,
          TError,
          Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSinglePredictionResultsetsResultsetSinglePredictionGet<TData = Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>, TError = HTTPValidationError>(
 params?: GetSinglePredictionResultsetsResultsetSinglePredictionGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>,
          TError,
          Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSinglePredictionResultsetsResultsetSinglePredictionGet<TData = Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>, TError = HTTPValidationError>(
 params?: GetSinglePredictionResultsetsResultsetSinglePredictionGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Single Prediction Resultsets
 */

export function useGetSinglePredictionResultsetsResultsetSinglePredictionGet<TData = Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>, TError = HTTPValidationError>(
 params?: GetSinglePredictionResultsetsResultsetSinglePredictionGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetsResultsetSinglePredictionGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSinglePredictionResultsetsResultsetSinglePredictionGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get Single Prediction Resultsets Count
 */
export const getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet = (
    params?: GetSinglePredictionResultsetsCountResultsetSinglePredictionCountGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/resultset/single_prediction/count`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetSinglePredictionResultsetsCountResultsetSinglePredictionCountGetQueryKey = (params?: GetSinglePredictionResultsetsCountResultsetSinglePredictionCountGetParams,) => {
    return [`/resultset/single_prediction/count`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSinglePredictionResultsetsCountResultsetSinglePredictionCountGetQueryOptions = <TData = Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>, TError = HTTPValidationError>(params?: GetSinglePredictionResultsetsCountResultsetSinglePredictionCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSinglePredictionResultsetsCountResultsetSinglePredictionCountGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>> = ({ signal }) => getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSinglePredictionResultsetsCountResultsetSinglePredictionCountGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>>
export type GetSinglePredictionResultsetsCountResultsetSinglePredictionCountGetQueryError = HTTPValidationError


export function useGetSinglePredictionResultsetsCountResultsetSinglePredictionCountGet<TData = Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>, TError = HTTPValidationError>(
 params: undefined |  GetSinglePredictionResultsetsCountResultsetSinglePredictionCountGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>,
          TError,
          Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSinglePredictionResultsetsCountResultsetSinglePredictionCountGet<TData = Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>, TError = HTTPValidationError>(
 params?: GetSinglePredictionResultsetsCountResultsetSinglePredictionCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>,
          TError,
          Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSinglePredictionResultsetsCountResultsetSinglePredictionCountGet<TData = Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>, TError = HTTPValidationError>(
 params?: GetSinglePredictionResultsetsCountResultsetSinglePredictionCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Single Prediction Resultsets Count
 */

export function useGetSinglePredictionResultsetsCountResultsetSinglePredictionCountGet<TData = Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>, TError = HTTPValidationError>(
 params?: GetSinglePredictionResultsetsCountResultsetSinglePredictionCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetsCountResultsetSinglePredictionCountGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSinglePredictionResultsetsCountResultsetSinglePredictionCountGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the tags of Resultset.
 * @summary Get Resultset Tags
 */
export const getResultsetTagsResultsetTagsGet = (
    params?: GetResultsetTagsResultsetTagsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/resultset/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetResultsetTagsResultsetTagsGetQueryKey = (params?: GetResultsetTagsResultsetTagsGetParams,) => {
    return [`/resultset/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getGetResultsetTagsResultsetTagsGetQueryOptions = <TData = Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>, TError = HTTPValidationError>(params?: GetResultsetTagsResultsetTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResultsetTagsResultsetTagsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>> = ({ signal }) => getResultsetTagsResultsetTagsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResultsetTagsResultsetTagsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>>
export type GetResultsetTagsResultsetTagsGetQueryError = HTTPValidationError


export function useGetResultsetTagsResultsetTagsGet<TData = Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetResultsetTagsResultsetTagsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetTagsResultsetTagsGet<TData = Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>, TError = HTTPValidationError>(
 params?: GetResultsetTagsResultsetTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetTagsResultsetTagsGet<TData = Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>, TError = HTTPValidationError>(
 params?: GetResultsetTagsResultsetTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Resultset Tags
 */

export function useGetResultsetTagsResultsetTagsGet<TData = Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>, TError = HTTPValidationError>(
 params?: GetResultsetTagsResultsetTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetTagsResultsetTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResultsetTagsResultsetTagsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the tags of Resultset.
 * @summary Get Single Prediction Resultset Tags
 */
export const getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet = (
    params?: GetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/resultset/single_prediction/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGetQueryKey = (params?: GetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGetParams,) => {
    return [`/resultset/single_prediction/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGetQueryOptions = <TData = Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>, TError = HTTPValidationError>(params?: GetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>> = ({ signal }) => getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>>
export type GetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGetQueryError = HTTPValidationError


export function useGetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet<TData = Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet<TData = Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>, TError = HTTPValidationError>(
 params?: GetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet<TData = Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>, TError = HTTPValidationError>(
 params?: GetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Single Prediction Resultset Tags
 */

export function useGetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet<TData = Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>, TError = HTTPValidationError>(
 params?: GetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSinglePredictionResultsetTagsResultsetSinglePredictionTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSinglePredictionResultsetTagsResultsetSinglePredictionTagsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * POST request to add a prediction to a resultset

:param add_prediction_metadata: either a single prediction_hash or list of prediction_hash's to add
                                and the resultset_id
 * @summary Add Prediction
 */
export const addPredictionResultsetAddPredictionPost = (
    addPredictionToResultsetRequest: AddPredictionToResultsetRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MessageResponse>(
      {url: `/resultset/add_prediction`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addPredictionToResultsetRequest, signal
    },
      );
    }
  


export const getAddPredictionResultsetAddPredictionPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPredictionResultsetAddPredictionPost>>, TError,{data: AddPredictionToResultsetRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addPredictionResultsetAddPredictionPost>>, TError,{data: AddPredictionToResultsetRequest}, TContext> => {
    
const mutationKey = ['addPredictionResultsetAddPredictionPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addPredictionResultsetAddPredictionPost>>, {data: AddPredictionToResultsetRequest}> = (props) => {
          const {data} = props ?? {};

          return  addPredictionResultsetAddPredictionPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddPredictionResultsetAddPredictionPostMutationResult = NonNullable<Awaited<ReturnType<typeof addPredictionResultsetAddPredictionPost>>>
    export type AddPredictionResultsetAddPredictionPostMutationBody = AddPredictionToResultsetRequest
    export type AddPredictionResultsetAddPredictionPostMutationError = HTTPValidationError

    /**
 * @summary Add Prediction
 */
export const useAddPredictionResultsetAddPredictionPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPredictionResultsetAddPredictionPost>>, TError,{data: AddPredictionToResultsetRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof addPredictionResultsetAddPredictionPost>>,
        TError,
        {data: AddPredictionToResultsetRequest},
        TContext
      > => {

      const mutationOptions = getAddPredictionResultsetAddPredictionPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * GET request to get predictions metadata for a specific resultset

:param resultset_id: the id of the resultset
:param model_family_id: the id of the model_family to get the predictions
 * @summary Get Resultset Predictions Metadata
 */
export const getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet = (
    resultsetId: number,
    params?: GetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet200>(
      {url: `/resultset/predictions/${resultsetId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGetQueryKey = (resultsetId: number,
    params?: GetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGetParams,) => {
    return [`/resultset/predictions/${resultsetId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>, TError = HTTPValidationError>(resultsetId: number,
    params?: GetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGetQueryKey(resultsetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>> = ({ signal }) => getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet(resultsetId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(resultsetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>>
export type GetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGetQueryError = HTTPValidationError


export function useGetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params: undefined |  GetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Resultset Predictions Metadata
 */

export function useGetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetPredictionsMetadataResultsetPredictionsResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResultsetPredictionsMetadataResultsetPredictionsResultsetIdGetQueryOptions(resultsetId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get a dictionary of predictions grouped by model_family in a resultset

Predictions in the resultset that don't belong to a model_family will be put under "None"

:param resultset_id: the id of the resultset
 * @summary Get Resultset Model Families
 */
export const getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet = (
    resultsetId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet200>(
      {url: `/resultset/model_families/${resultsetId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetResultsetModelFamiliesResultsetModelFamiliesResultsetIdGetQueryKey = (resultsetId: number,) => {
    return [`/resultset/model_families/${resultsetId}`] as const;
    }

    
export const getGetResultsetModelFamiliesResultsetModelFamiliesResultsetIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>, TError = HTTPValidationError>(resultsetId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResultsetModelFamiliesResultsetModelFamiliesResultsetIdGetQueryKey(resultsetId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>> = ({ signal }) => getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet(resultsetId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(resultsetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResultsetModelFamiliesResultsetModelFamiliesResultsetIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>>
export type GetResultsetModelFamiliesResultsetModelFamiliesResultsetIdGetQueryError = HTTPValidationError


export function useGetResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Resultset Model Families
 */

export function useGetResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetModelFamiliesResultsetModelFamiliesResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResultsetModelFamiliesResultsetModelFamiliesResultsetIdGetQueryOptions(resultsetId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to retrieve molecule highlighting data for a resultset.

Returns MH data in the same shape as dataframe_v2's model_hash.X.molecule_highlighting,
but scoped by optional model_hash, molecule_index, and method_filter parameters.
 * @summary Get Resultset Molecule Highlighting
 */
export const getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet = (
    resultsetId: number,
    params?: GetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/resultset/molecule_highlighting/${resultsetId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGetQueryKey = (resultsetId: number,
    params?: GetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGetParams,) => {
    return [`/resultset/molecule_highlighting/${resultsetId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>, TError = HTTPValidationError>(resultsetId: number,
    params?: GetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGetQueryKey(resultsetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>> = ({ signal }) => getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet(resultsetId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(resultsetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>>
export type GetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGetQueryError = HTTPValidationError


export function useGetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params: undefined |  GetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Resultset Molecule Highlighting
 */

export function useGetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResultsetMoleculeHighlightingResultsetMoleculeHighlightingResultsetIdGetQueryOptions(resultsetId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get Resultset Explainability
 */
export const getResultsetExplainabilityResultsetExplainabilityResultsetIdGet = (
    resultsetId: number,
    params?: GetResultsetExplainabilityResultsetExplainabilityResultsetIdGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ResultsetExplainabilityResponse>(
      {url: `/resultset/explainability/${resultsetId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetResultsetExplainabilityResultsetExplainabilityResultsetIdGetQueryKey = (resultsetId: number,
    params?: GetResultsetExplainabilityResultsetExplainabilityResultsetIdGetParams,) => {
    return [`/resultset/explainability/${resultsetId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetResultsetExplainabilityResultsetExplainabilityResultsetIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>, TError = HTTPValidationError>(resultsetId: number,
    params?: GetResultsetExplainabilityResultsetExplainabilityResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResultsetExplainabilityResultsetExplainabilityResultsetIdGetQueryKey(resultsetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>> = ({ signal }) => getResultsetExplainabilityResultsetExplainabilityResultsetIdGet(resultsetId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(resultsetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResultsetExplainabilityResultsetExplainabilityResultsetIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>>
export type GetResultsetExplainabilityResultsetExplainabilityResultsetIdGetQueryError = HTTPValidationError


export function useGetResultsetExplainabilityResultsetExplainabilityResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params: undefined |  GetResultsetExplainabilityResultsetExplainabilityResultsetIdGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetExplainabilityResultsetExplainabilityResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetResultsetExplainabilityResultsetExplainabilityResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetExplainabilityResultsetExplainabilityResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetResultsetExplainabilityResultsetExplainabilityResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Resultset Explainability
 */

export function useGetResultsetExplainabilityResultsetExplainabilityResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetResultsetExplainabilityResultsetExplainabilityResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetExplainabilityResultsetExplainabilityResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResultsetExplainabilityResultsetExplainabilityResultsetIdGetQueryOptions(resultsetId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the dataframe of the resultest with the
given resultset_id. This will get all the predictions and join them
along the structure column.

:param resultset_id: the id of the resultset
:param applicability_domain: Query parameter boolean to also join Applicability Domain results
:param include_duplicates: Query parameter boolean to determine whether to include extra column with a duplicate flag
:param include_duplicate_values: Query parameter boolean to determine whether to include extra column with a duplicate values.
                                include_duplicates MUST be True. Setting this to true will include the value for the Duplicate attribute
 * @summary Get Resultset V2
 */
export const getResultsetV2ResultsetDataframeV2ResultsetIdGet = (
    resultsetId: number,
    params?: GetResultsetV2ResultsetDataframeV2ResultsetIdGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/resultset/dataframe_v2/${resultsetId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetResultsetV2ResultsetDataframeV2ResultsetIdGetQueryKey = (resultsetId: number,
    params?: GetResultsetV2ResultsetDataframeV2ResultsetIdGetParams,) => {
    return [`/resultset/dataframe_v2/${resultsetId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetResultsetV2ResultsetDataframeV2ResultsetIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>, TError = HTTPValidationError>(resultsetId: number,
    params?: GetResultsetV2ResultsetDataframeV2ResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResultsetV2ResultsetDataframeV2ResultsetIdGetQueryKey(resultsetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>> = ({ signal }) => getResultsetV2ResultsetDataframeV2ResultsetIdGet(resultsetId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(resultsetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResultsetV2ResultsetDataframeV2ResultsetIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>>
export type GetResultsetV2ResultsetDataframeV2ResultsetIdGetQueryError = HTTPValidationError


export function useGetResultsetV2ResultsetDataframeV2ResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params: undefined |  GetResultsetV2ResultsetDataframeV2ResultsetIdGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetV2ResultsetDataframeV2ResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetResultsetV2ResultsetDataframeV2ResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetV2ResultsetDataframeV2ResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetResultsetV2ResultsetDataframeV2ResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Resultset V2
 */

export function useGetResultsetV2ResultsetDataframeV2ResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetResultsetV2ResultsetDataframeV2ResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetV2ResultsetDataframeV2ResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResultsetV2ResultsetDataframeV2ResultsetIdGetQueryOptions(resultsetId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the dataframe of the resultest with the
given resultset_id. This will get all the predictions and join them
along the structure column.

:param resultset_id: the id of the resultset
:param model_family_id: the id of the model_family to get the predictions dataframe
:param applicability_domain: Query parameter boolean to also join Applicability Domain results
 * @summary Get Resultset
 */
export const getResultsetResultsetDataframeResultsetIdGet = (
    resultsetId: number,
    params?: GetResultsetResultsetDataframeResultsetIdGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/resultset/dataframe/${resultsetId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetResultsetResultsetDataframeResultsetIdGetQueryKey = (resultsetId: number,
    params?: GetResultsetResultsetDataframeResultsetIdGetParams,) => {
    return [`/resultset/dataframe/${resultsetId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetResultsetResultsetDataframeResultsetIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>, TError = HTTPValidationError>(resultsetId: number,
    params?: GetResultsetResultsetDataframeResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResultsetResultsetDataframeResultsetIdGetQueryKey(resultsetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>> = ({ signal }) => getResultsetResultsetDataframeResultsetIdGet(resultsetId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(resultsetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResultsetResultsetDataframeResultsetIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>>
export type GetResultsetResultsetDataframeResultsetIdGetQueryError = HTTPValidationError


export function useGetResultsetResultsetDataframeResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params: undefined |  GetResultsetResultsetDataframeResultsetIdGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetResultsetDataframeResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetResultsetResultsetDataframeResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultsetResultsetDataframeResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetResultsetResultsetDataframeResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Resultset
 */

export function useGetResultsetResultsetDataframeResultsetIdGet<TData = Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetResultsetResultsetDataframeResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResultsetResultsetDataframeResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResultsetResultsetDataframeResultsetIdGetQueryOptions(resultsetId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Predict
 */
export const predictResultsetPredictPost = (
    aCPredictDAGRequestModel: ACPredictDAGRequestModel,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/resultset/predict`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aCPredictDAGRequestModel, signal
    },
      );
    }
  


export const getPredictResultsetPredictPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof predictResultsetPredictPost>>, TError,{data: ACPredictDAGRequestModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof predictResultsetPredictPost>>, TError,{data: ACPredictDAGRequestModel}, TContext> => {
    
const mutationKey = ['predictResultsetPredictPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof predictResultsetPredictPost>>, {data: ACPredictDAGRequestModel}> = (props) => {
          const {data} = props ?? {};

          return  predictResultsetPredictPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PredictResultsetPredictPostMutationResult = NonNullable<Awaited<ReturnType<typeof predictResultsetPredictPost>>>
    export type PredictResultsetPredictPostMutationBody = ACPredictDAGRequestModel
    export type PredictResultsetPredictPostMutationError = HTTPValidationError

    /**
 * @summary Predict
 */
export const usePredictResultsetPredictPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof predictResultsetPredictPost>>, TError,{data: ACPredictDAGRequestModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof predictResultsetPredictPost>>,
        TError,
        {data: ACPredictDAGRequestModel},
        TContext
      > => {

      const mutationOptions = getPredictResultsetPredictPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Single Predict
 */
export const singlePredictResultsetSinglePredictPost = (
    aCSinglePredictDAGRequestModel: ACSinglePredictDAGRequestModel,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/resultset/single_predict`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aCSinglePredictDAGRequestModel, signal
    },
      );
    }
  


export const getSinglePredictResultsetSinglePredictPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof singlePredictResultsetSinglePredictPost>>, TError,{data: ACSinglePredictDAGRequestModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof singlePredictResultsetSinglePredictPost>>, TError,{data: ACSinglePredictDAGRequestModel}, TContext> => {
    
const mutationKey = ['singlePredictResultsetSinglePredictPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof singlePredictResultsetSinglePredictPost>>, {data: ACSinglePredictDAGRequestModel}> = (props) => {
          const {data} = props ?? {};

          return  singlePredictResultsetSinglePredictPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SinglePredictResultsetSinglePredictPostMutationResult = NonNullable<Awaited<ReturnType<typeof singlePredictResultsetSinglePredictPost>>>
    export type SinglePredictResultsetSinglePredictPostMutationBody = ACSinglePredictDAGRequestModel
    export type SinglePredictResultsetSinglePredictPostMutationError = HTTPValidationError

    /**
 * @summary Single Predict
 */
export const useSinglePredictResultsetSinglePredictPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof singlePredictResultsetSinglePredictPost>>, TError,{data: ACSinglePredictDAGRequestModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof singlePredictResultsetSinglePredictPost>>,
        TError,
        {data: ACSinglePredictDAGRequestModel},
        TContext
      > => {

      const mutationOptions = getSinglePredictResultsetSinglePredictPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * DELETE request for resultsets
 * @summary Delete Resultset
 */
export const deleteResultsetResultsetResultsetIdDelete = (
    resultsetId: number,
    params?: DeleteResultsetResultsetResultsetIdDeleteParams,
 ) => {
      
      
      return customInstance<void>(
      {url: `/resultset/${resultsetId}`, method: 'DELETE',
        params
    },
      );
    }
  


export const getDeleteResultsetResultsetResultsetIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteResultsetResultsetResultsetIdDelete>>, TError,{resultsetId: number;params?: DeleteResultsetResultsetResultsetIdDeleteParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteResultsetResultsetResultsetIdDelete>>, TError,{resultsetId: number;params?: DeleteResultsetResultsetResultsetIdDeleteParams}, TContext> => {
    
const mutationKey = ['deleteResultsetResultsetResultsetIdDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteResultsetResultsetResultsetIdDelete>>, {resultsetId: number;params?: DeleteResultsetResultsetResultsetIdDeleteParams}> = (props) => {
          const {resultsetId,params} = props ?? {};

          return  deleteResultsetResultsetResultsetIdDelete(resultsetId,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteResultsetResultsetResultsetIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteResultsetResultsetResultsetIdDelete>>>
    
    export type DeleteResultsetResultsetResultsetIdDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete Resultset
 */
export const useDeleteResultsetResultsetResultsetIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteResultsetResultsetResultsetIdDelete>>, TError,{resultsetId: number;params?: DeleteResultsetResultsetResultsetIdDeleteParams}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteResultsetResultsetResultsetIdDelete>>,
        TError,
        {resultsetId: number;params?: DeleteResultsetResultsetResultsetIdDeleteParams},
        TContext
      > => {

      const mutationOptions = getDeleteResultsetResultsetResultsetIdDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * GET request to download a resultset
 * @summary Download Resultset
 */
export const downloadResultsetResultsetDownloadResultsetIdGet = (
    resultsetId: number,
    params?: DownloadResultsetResultsetDownloadResultsetIdGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/resultset/download/${resultsetId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getDownloadResultsetResultsetDownloadResultsetIdGetQueryKey = (resultsetId: number,
    params?: DownloadResultsetResultsetDownloadResultsetIdGetParams,) => {
    return [`/resultset/download/${resultsetId}`, ...(params ? [params]: [])] as const;
    }

    
export const getDownloadResultsetResultsetDownloadResultsetIdGetQueryOptions = <TData = Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>, TError = HTTPValidationError>(resultsetId: number,
    params?: DownloadResultsetResultsetDownloadResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadResultsetResultsetDownloadResultsetIdGetQueryKey(resultsetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>> = ({ signal }) => downloadResultsetResultsetDownloadResultsetIdGet(resultsetId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(resultsetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadResultsetResultsetDownloadResultsetIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>>
export type DownloadResultsetResultsetDownloadResultsetIdGetQueryError = HTTPValidationError


export function useDownloadResultsetResultsetDownloadResultsetIdGet<TData = Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params: undefined |  DownloadResultsetResultsetDownloadResultsetIdGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadResultsetResultsetDownloadResultsetIdGet<TData = Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: DownloadResultsetResultsetDownloadResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadResultsetResultsetDownloadResultsetIdGet<TData = Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: DownloadResultsetResultsetDownloadResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download Resultset
 */

export function useDownloadResultsetResultsetDownloadResultsetIdGet<TData = Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: DownloadResultsetResultsetDownloadResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadResultsetResultsetDownloadResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadResultsetResultsetDownloadResultsetIdGetQueryOptions(resultsetId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Dataset Visualization
 */
export const datasetVisualizationResultsetDatasetVisualizationPost = (
    datasetVisualizationDAGRequestModel: DatasetVisualizationDAGRequestModel,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/resultset/dataset_visualization`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: datasetVisualizationDAGRequestModel, signal
    },
      );
    }
  


export const getDatasetVisualizationResultsetDatasetVisualizationPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetVisualizationResultsetDatasetVisualizationPost>>, TError,{data: DatasetVisualizationDAGRequestModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof datasetVisualizationResultsetDatasetVisualizationPost>>, TError,{data: DatasetVisualizationDAGRequestModel}, TContext> => {
    
const mutationKey = ['datasetVisualizationResultsetDatasetVisualizationPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof datasetVisualizationResultsetDatasetVisualizationPost>>, {data: DatasetVisualizationDAGRequestModel}> = (props) => {
          const {data} = props ?? {};

          return  datasetVisualizationResultsetDatasetVisualizationPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DatasetVisualizationResultsetDatasetVisualizationPostMutationResult = NonNullable<Awaited<ReturnType<typeof datasetVisualizationResultsetDatasetVisualizationPost>>>
    export type DatasetVisualizationResultsetDatasetVisualizationPostMutationBody = DatasetVisualizationDAGRequestModel
    export type DatasetVisualizationResultsetDatasetVisualizationPostMutationError = HTTPValidationError

    /**
 * @summary Dataset Visualization
 */
export const useDatasetVisualizationResultsetDatasetVisualizationPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetVisualizationResultsetDatasetVisualizationPost>>, TError,{data: DatasetVisualizationDAGRequestModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof datasetVisualizationResultsetDatasetVisualizationPost>>,
        TError,
        {data: DatasetVisualizationDAGRequestModel},
        TContext
      > => {

      const mutationOptions = getDatasetVisualizationResultsetDatasetVisualizationPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * GET request to get a list of the dataset_visualizations associated to the resultest with the
given resultset_id.

:param resultset_id: the id of the resultset
 * @summary Get Dataset Visualizations
 */
export const getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet = (
    resultsetId: number,
    params?: GetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/resultset/dataset_visualization/${resultsetId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGetQueryKey = (resultsetId: number,
    params?: GetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGetParams,) => {
    return [`/resultset/dataset_visualization/${resultsetId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>, TError = HTTPValidationError>(resultsetId: number,
    params?: GetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGetQueryKey(resultsetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>> = ({ signal }) => getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet(resultsetId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(resultsetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>>
export type GetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGetQueryError = HTTPValidationError


export function useGetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet<TData = Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params: undefined |  GetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet<TData = Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet<TData = Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Dataset Visualizations
 */

export function useGetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet<TData = Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    params?: GetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatasetVisualizationsResultsetDatasetVisualizationResultsetIdGetQueryOptions(resultsetId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to download a dataset visualization for a specific resultset.

:param resultset_id: the id of the resultset
:param dataset_visualization_hash: the file_hash of the dataset_visualization
:param include_smiles: boolean on whether to smiles for training related datasets
:param file_type: download file type
 * @summary Download Resultset Dataset Visualization
 */
export const downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet = (
    resultsetId: number,
    dataVisualizationHash: string,
    params?: DownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/resultset/dataset_visualization_download/${resultsetId}/${dataVisualizationHash}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getDownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGetQueryKey = (resultsetId: number,
    dataVisualizationHash: string,
    params?: DownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGetParams,) => {
    return [`/resultset/dataset_visualization_download/${resultsetId}/${dataVisualizationHash}`, ...(params ? [params]: [])] as const;
    }

    
export const getDownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGetQueryOptions = <TData = Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>, TError = HTTPValidationError>(resultsetId: number,
    dataVisualizationHash: string,
    params?: DownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGetQueryKey(resultsetId,dataVisualizationHash,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>> = ({ signal }) => downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet(resultsetId,dataVisualizationHash,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(resultsetId && dataVisualizationHash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGetQueryResult = NonNullable<Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>>
export type DownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGetQueryError = HTTPValidationError


export function useDownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet<TData = Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    dataVisualizationHash: string,
    params: undefined |  DownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>,
          TError,
          Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet<TData = Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    dataVisualizationHash: string,
    params?: DownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>,
          TError,
          Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet<TData = Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    dataVisualizationHash: string,
    params?: DownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download Resultset Dataset Visualization
 */

export function useDownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet<TData = Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>, TError = HTTPValidationError>(
 resultsetId: number,
    dataVisualizationHash: string,
    params?: DownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadResultsetDatasetVisualizationResultsetDatasetVisualizationDownloadResultsetIdDataVisualizationHashGetQueryOptions(resultsetId,dataVisualizationHash,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get list of readacross (metadata ONLY)
 * @summary Get Readacross
 */
export const getReadacrossReadacrossGet = (
    params?: GetReadacrossReadacrossGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetReadacrossReadacrossGet200>(
      {url: `/readacross/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetReadacrossReadacrossGetQueryKey = (params?: GetReadacrossReadacrossGetParams,) => {
    return [`/readacross/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetReadacrossReadacrossGetQueryOptions = <TData = Awaited<ReturnType<typeof getReadacrossReadacrossGet>>, TError = HTTPValidationError>(params?: GetReadacrossReadacrossGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossReadacrossGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReadacrossReadacrossGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReadacrossReadacrossGet>>> = ({ signal }) => getReadacrossReadacrossGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReadacrossReadacrossGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReadacrossReadacrossGetQueryResult = NonNullable<Awaited<ReturnType<typeof getReadacrossReadacrossGet>>>
export type GetReadacrossReadacrossGetQueryError = HTTPValidationError


export function useGetReadacrossReadacrossGet<TData = Awaited<ReturnType<typeof getReadacrossReadacrossGet>>, TError = HTTPValidationError>(
 params: undefined |  GetReadacrossReadacrossGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossReadacrossGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReadacrossReadacrossGet>>,
          TError,
          Awaited<ReturnType<typeof getReadacrossReadacrossGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReadacrossReadacrossGet<TData = Awaited<ReturnType<typeof getReadacrossReadacrossGet>>, TError = HTTPValidationError>(
 params?: GetReadacrossReadacrossGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossReadacrossGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReadacrossReadacrossGet>>,
          TError,
          Awaited<ReturnType<typeof getReadacrossReadacrossGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReadacrossReadacrossGet<TData = Awaited<ReturnType<typeof getReadacrossReadacrossGet>>, TError = HTTPValidationError>(
 params?: GetReadacrossReadacrossGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossReadacrossGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Readacross
 */

export function useGetReadacrossReadacrossGet<TData = Awaited<ReturnType<typeof getReadacrossReadacrossGet>>, TError = HTTPValidationError>(
 params?: GetReadacrossReadacrossGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossReadacrossGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReadacrossReadacrossGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get list of readacross (metadata ONLY)
 * @summary Get Readacross Count
 */
export const getReadacrossCountReadacrossCountGet = (
    params?: GetReadacrossCountReadacrossCountGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/readacross/count`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetReadacrossCountReadacrossCountGetQueryKey = (params?: GetReadacrossCountReadacrossCountGetParams,) => {
    return [`/readacross/count`, ...(params ? [params]: [])] as const;
    }

    
export const getGetReadacrossCountReadacrossCountGetQueryOptions = <TData = Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>, TError = HTTPValidationError>(params?: GetReadacrossCountReadacrossCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReadacrossCountReadacrossCountGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>> = ({ signal }) => getReadacrossCountReadacrossCountGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReadacrossCountReadacrossCountGetQueryResult = NonNullable<Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>>
export type GetReadacrossCountReadacrossCountGetQueryError = HTTPValidationError


export function useGetReadacrossCountReadacrossCountGet<TData = Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>, TError = HTTPValidationError>(
 params: undefined |  GetReadacrossCountReadacrossCountGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>,
          TError,
          Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReadacrossCountReadacrossCountGet<TData = Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>, TError = HTTPValidationError>(
 params?: GetReadacrossCountReadacrossCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>,
          TError,
          Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReadacrossCountReadacrossCountGet<TData = Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>, TError = HTTPValidationError>(
 params?: GetReadacrossCountReadacrossCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Readacross Count
 */

export function useGetReadacrossCountReadacrossCountGet<TData = Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>, TError = HTTPValidationError>(
 params?: GetReadacrossCountReadacrossCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossCountReadacrossCountGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReadacrossCountReadacrossCountGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the tags of Read Across.
 * @summary Get Readacross Tags
 */
export const getReadacrossTagsReadacrossTagsGet = (
    params?: GetReadacrossTagsReadacrossTagsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/readacross/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetReadacrossTagsReadacrossTagsGetQueryKey = (params?: GetReadacrossTagsReadacrossTagsGetParams,) => {
    return [`/readacross/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getGetReadacrossTagsReadacrossTagsGetQueryOptions = <TData = Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>, TError = HTTPValidationError>(params?: GetReadacrossTagsReadacrossTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReadacrossTagsReadacrossTagsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>> = ({ signal }) => getReadacrossTagsReadacrossTagsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReadacrossTagsReadacrossTagsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>>
export type GetReadacrossTagsReadacrossTagsGetQueryError = HTTPValidationError


export function useGetReadacrossTagsReadacrossTagsGet<TData = Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetReadacrossTagsReadacrossTagsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReadacrossTagsReadacrossTagsGet<TData = Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>, TError = HTTPValidationError>(
 params?: GetReadacrossTagsReadacrossTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReadacrossTagsReadacrossTagsGet<TData = Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>, TError = HTTPValidationError>(
 params?: GetReadacrossTagsReadacrossTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Readacross Tags
 */

export function useGetReadacrossTagsReadacrossTagsGet<TData = Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>, TError = HTTPValidationError>(
 params?: GetReadacrossTagsReadacrossTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossTagsReadacrossTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReadacrossTagsReadacrossTagsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get the dataframe of the dataset with the
given dataset_hash

:param dataset_hash: the file_hash of the dataset
:param applicability_domain: Query parameter boolean to also join Applicability Domain results
 * @summary Get Readacross Dataframe
 */
export const getReadacrossDataframeReadacrossDataframeReadacrossIdGet = (
    readacrossId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/readacross/dataframe/${readacrossId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetReadacrossDataframeReadacrossDataframeReadacrossIdGetQueryKey = (readacrossId: string,) => {
    return [`/readacross/dataframe/${readacrossId}`] as const;
    }

    
export const getGetReadacrossDataframeReadacrossDataframeReadacrossIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>, TError = HTTPValidationError>(readacrossId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReadacrossDataframeReadacrossDataframeReadacrossIdGetQueryKey(readacrossId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>> = ({ signal }) => getReadacrossDataframeReadacrossDataframeReadacrossIdGet(readacrossId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(readacrossId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReadacrossDataframeReadacrossDataframeReadacrossIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>>
export type GetReadacrossDataframeReadacrossDataframeReadacrossIdGetQueryError = HTTPValidationError


export function useGetReadacrossDataframeReadacrossDataframeReadacrossIdGet<TData = Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>, TError = HTTPValidationError>(
 readacrossId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>,
          TError,
          Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReadacrossDataframeReadacrossDataframeReadacrossIdGet<TData = Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>, TError = HTTPValidationError>(
 readacrossId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>,
          TError,
          Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReadacrossDataframeReadacrossDataframeReadacrossIdGet<TData = Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>, TError = HTTPValidationError>(
 readacrossId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Readacross Dataframe
 */

export function useGetReadacrossDataframeReadacrossDataframeReadacrossIdGet<TData = Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>, TError = HTTPValidationError>(
 readacrossId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReadacrossDataframeReadacrossDataframeReadacrossIdGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReadacrossDataframeReadacrossDataframeReadacrossIdGetQueryOptions(readacrossId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get list of datasets (metadata ONLY) for readacross purposes

The reason this exist to bypass the cpi_confidential files
 * @summary Get Datasets For Readacross
 */
export const getDatasetsForReadacrossReadacrossDatasetsGet = (
    params?: GetDatasetsForReadacrossReadacrossDatasetsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DatasetListResponse>(
      {url: `/readacross/datasets`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetDatasetsForReadacrossReadacrossDatasetsGetQueryKey = (params?: GetDatasetsForReadacrossReadacrossDatasetsGetParams,) => {
    return [`/readacross/datasets`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDatasetsForReadacrossReadacrossDatasetsGetQueryOptions = <TData = Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>, TError = HTTPValidationError>(params?: GetDatasetsForReadacrossReadacrossDatasetsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatasetsForReadacrossReadacrossDatasetsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>> = ({ signal }) => getDatasetsForReadacrossReadacrossDatasetsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatasetsForReadacrossReadacrossDatasetsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>>
export type GetDatasetsForReadacrossReadacrossDatasetsGetQueryError = HTTPValidationError


export function useGetDatasetsForReadacrossReadacrossDatasetsGet<TData = Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetDatasetsForReadacrossReadacrossDatasetsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetsForReadacrossReadacrossDatasetsGet<TData = Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>, TError = HTTPValidationError>(
 params?: GetDatasetsForReadacrossReadacrossDatasetsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatasetsForReadacrossReadacrossDatasetsGet<TData = Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>, TError = HTTPValidationError>(
 params?: GetDatasetsForReadacrossReadacrossDatasetsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Datasets For Readacross
 */

export function useGetDatasetsForReadacrossReadacrossDatasetsGet<TData = Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>, TError = HTTPValidationError>(
 params?: GetDatasetsForReadacrossReadacrossDatasetsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatasetsForReadacrossReadacrossDatasetsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatasetsForReadacrossReadacrossDatasetsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET request to get list of model_families (metadata ONLY)
 * @summary Get Model Families
 */
export const getModelFamiliesReadacrossModelFamilyDatasetsGet = (
    params?: GetModelFamiliesReadacrossModelFamilyDatasetsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ModelFamilyDatasetListResponse>(
      {url: `/readacross/model_family_datasets`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetModelFamiliesReadacrossModelFamilyDatasetsGetQueryKey = (params?: GetModelFamiliesReadacrossModelFamilyDatasetsGetParams,) => {
    return [`/readacross/model_family_datasets`, ...(params ? [params]: [])] as const;
    }

    
export const getGetModelFamiliesReadacrossModelFamilyDatasetsGetQueryOptions = <TData = Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>, TError = HTTPValidationError>(params?: GetModelFamiliesReadacrossModelFamilyDatasetsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelFamiliesReadacrossModelFamilyDatasetsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>> = ({ signal }) => getModelFamiliesReadacrossModelFamilyDatasetsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelFamiliesReadacrossModelFamilyDatasetsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>>
export type GetModelFamiliesReadacrossModelFamilyDatasetsGetQueryError = HTTPValidationError


export function useGetModelFamiliesReadacrossModelFamilyDatasetsGet<TData = Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetModelFamiliesReadacrossModelFamilyDatasetsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamiliesReadacrossModelFamilyDatasetsGet<TData = Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>, TError = HTTPValidationError>(
 params?: GetModelFamiliesReadacrossModelFamilyDatasetsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>,
          TError,
          Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelFamiliesReadacrossModelFamilyDatasetsGet<TData = Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>, TError = HTTPValidationError>(
 params?: GetModelFamiliesReadacrossModelFamilyDatasetsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Model Families
 */

export function useGetModelFamiliesReadacrossModelFamilyDatasetsGet<TData = Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>, TError = HTTPValidationError>(
 params?: GetModelFamiliesReadacrossModelFamilyDatasetsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelFamiliesReadacrossModelFamilyDatasetsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelFamiliesReadacrossModelFamilyDatasetsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * POST request to update a dataset.

:param dataset_hash: file_hash of the dataset to update. 
:param metadata: metadata for dataset
 * @summary Update Readacross
 */
export const updateReadacrossReadacrossUpdateReadacrossIdPut = (
    readacrossId: string,
    updateReadAcrossRequest: UpdateReadAcrossRequest,
 ) => {
      
      
      return customInstance<MessageResponse>(
      {url: `/readacross/update/${readacrossId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateReadAcrossRequest
    },
      );
    }
  


export const getUpdateReadacrossReadacrossUpdateReadacrossIdPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReadacrossReadacrossUpdateReadacrossIdPut>>, TError,{readacrossId: string;data: UpdateReadAcrossRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateReadacrossReadacrossUpdateReadacrossIdPut>>, TError,{readacrossId: string;data: UpdateReadAcrossRequest}, TContext> => {
    
const mutationKey = ['updateReadacrossReadacrossUpdateReadacrossIdPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReadacrossReadacrossUpdateReadacrossIdPut>>, {readacrossId: string;data: UpdateReadAcrossRequest}> = (props) => {
          const {readacrossId,data} = props ?? {};

          return  updateReadacrossReadacrossUpdateReadacrossIdPut(readacrossId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateReadacrossReadacrossUpdateReadacrossIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateReadacrossReadacrossUpdateReadacrossIdPut>>>
    export type UpdateReadacrossReadacrossUpdateReadacrossIdPutMutationBody = UpdateReadAcrossRequest
    export type UpdateReadacrossReadacrossUpdateReadacrossIdPutMutationError = HTTPValidationError

    /**
 * @summary Update Readacross
 */
export const useUpdateReadacrossReadacrossUpdateReadacrossIdPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReadacrossReadacrossUpdateReadacrossIdPut>>, TError,{readacrossId: string;data: UpdateReadAcrossRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof updateReadacrossReadacrossUpdateReadacrossIdPut>>,
        TError,
        {readacrossId: string;data: UpdateReadAcrossRequest},
        TContext
      > => {

      const mutationOptions = getUpdateReadacrossReadacrossUpdateReadacrossIdPutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Readacross Predict
 */
export const readacrossPredictReadacrossPredictPost = (
    readAcrossDAGRequestModel: ReadAcrossDAGRequestModel,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/readacross/predict`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: readAcrossDAGRequestModel, signal
    },
      );
    }
  


export const getReadacrossPredictReadacrossPredictPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readacrossPredictReadacrossPredictPost>>, TError,{data: ReadAcrossDAGRequestModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof readacrossPredictReadacrossPredictPost>>, TError,{data: ReadAcrossDAGRequestModel}, TContext> => {
    
const mutationKey = ['readacrossPredictReadacrossPredictPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof readacrossPredictReadacrossPredictPost>>, {data: ReadAcrossDAGRequestModel}> = (props) => {
          const {data} = props ?? {};

          return  readacrossPredictReadacrossPredictPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReadacrossPredictReadacrossPredictPostMutationResult = NonNullable<Awaited<ReturnType<typeof readacrossPredictReadacrossPredictPost>>>
    export type ReadacrossPredictReadacrossPredictPostMutationBody = ReadAcrossDAGRequestModel
    export type ReadacrossPredictReadacrossPredictPostMutationError = HTTPValidationError

    /**
 * @summary Readacross Predict
 */
export const useReadacrossPredictReadacrossPredictPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readacrossPredictReadacrossPredictPost>>, TError,{data: ReadAcrossDAGRequestModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof readacrossPredictReadacrossPredictPost>>,
        TError,
        {data: ReadAcrossDAGRequestModel},
        TContext
      > => {

      const mutationOptions = getReadacrossPredictReadacrossPredictPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * DELETE request for readacross
 * @summary Delete Readacross
 */
export const deleteReadacrossReadacrossReadacrossIdDelete = (
    readacrossId: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/readacross/${readacrossId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteReadacrossReadacrossReadacrossIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReadacrossReadacrossReadacrossIdDelete>>, TError,{readacrossId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteReadacrossReadacrossReadacrossIdDelete>>, TError,{readacrossId: number}, TContext> => {
    
const mutationKey = ['deleteReadacrossReadacrossReadacrossIdDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteReadacrossReadacrossReadacrossIdDelete>>, {readacrossId: number}> = (props) => {
          const {readacrossId} = props ?? {};

          return  deleteReadacrossReadacrossReadacrossIdDelete(readacrossId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteReadacrossReadacrossReadacrossIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteReadacrossReadacrossReadacrossIdDelete>>>
    
    export type DeleteReadacrossReadacrossReadacrossIdDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete Readacross
 */
export const useDeleteReadacrossReadacrossReadacrossIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReadacrossReadacrossReadacrossIdDelete>>, TError,{readacrossId: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteReadacrossReadacrossReadacrossIdDelete>>,
        TError,
        {readacrossId: number},
        TContext
      > => {

      const mutationOptions = getDeleteReadacrossReadacrossReadacrossIdDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * GET request to get the tags of Data Files.
 * @summary Get Tags
 */
export const getTagsTagsGet = (
    params?: GetTagsTagsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetTagsTagsGetQueryKey = (params?: GetTagsTagsGetParams,) => {
    return [`/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTagsTagsGetQueryOptions = <TData = Awaited<ReturnType<typeof getTagsTagsGet>>, TError = HTTPValidationError>(params?: GetTagsTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTagsTagsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagsTagsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagsTagsGet>>> = ({ signal }) => getTagsTagsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagsTagsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTagsTagsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getTagsTagsGet>>>
export type GetTagsTagsGetQueryError = HTTPValidationError


export function useGetTagsTagsGet<TData = Awaited<ReturnType<typeof getTagsTagsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetTagsTagsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTagsTagsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTagsTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getTagsTagsGet>>
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTagsTagsGet<TData = Awaited<ReturnType<typeof getTagsTagsGet>>, TError = HTTPValidationError>(
 params?: GetTagsTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTagsTagsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTagsTagsGet>>,
          TError,
          Awaited<ReturnType<typeof getTagsTagsGet>>
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTagsTagsGet<TData = Awaited<ReturnType<typeof getTagsTagsGet>>, TError = HTTPValidationError>(
 params?: GetTagsTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTagsTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Tags
 */

export function useGetTagsTagsGet<TData = Awaited<ReturnType<typeof getTagsTagsGet>>, TError = HTTPValidationError>(
 params?: GetTagsTagsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTagsTagsGet>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTagsTagsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




